//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Check, ChevronLeftOutlined, ChevronRightOutlined, Close, KeyboardArrowDownOutlined, Download } from '@mui/icons-material';
import { Button, Input, Switch, TextField } from '@mui/material';
//  -- Components ---------------------
import { Dropdown, Row, Tooltip } from 'antd';
import Loading from 'components/Loading';
import moment from 'moment';
import { lighten } from 'polished';
import React, { use, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
//  -- Thunks -------------------------
import { handleListClassSubmissions, handleUpdateGrade, handleUpdateSubmission } from 'store/submissions/thunks';
import styled from 'styled-components';
//  -- Constants ----------------------
import { ArrowRight } from '@mui/icons-material';
import AudioRecorder from "features/AudeoRecorderNew";
import {  useNavigate } from "react-router-dom";
import COLOR from 'utils/constants/color';
//  -- Lib ----------------------------
import { filter, find, findIndex, get, groupBy, has, map, floor } from 'lodash';
import { getConfigForDiff, imageFetch, imageFetchFromPodcast, isVideo } from 'utils/lib/ebookHelper';

import { Accordion as MuiAccordion, AccordionDetails as MuiAccordionDetails, AccordionSummary as MuiAccordionSummary, Typography } from '@mui/material';

import { EyeOutlined, LeftOutlined } from '@ant-design/icons';
import * as Sentry from '@sentry/react';
import GradeDisplay from 'components/GradeDisplay';
import { useOrientation } from 'components/hooks';
import usecheckIFrame from 'components/hooks/usecheckIFrame';
import SpinLoader from 'components/Loader/SpinLoader';
import { AlertSakeBar } from 'components/UI';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { useTabletDetection } from 'containers/chat/hooks';
import AssignmentImgModal from 'features/AssignmentImgModal';
import StudentAssignmentTrackingModal from 'components/StudentAssignmentTracking/StudentAssignmentTrackingModal';
import { getSubmissionActivityLogId } from 'components/StudentAssignmentTracking/studentAssignmentTrackingStatic';
import { buildTrackingLogSources } from 'components/StudentAssignmentTracking/studentAssignmentTrackingUtils';
import SplitPane from 'split-pane-react';
import { handleUpdateCanvasGradeInBatch } from 'store/canvas/thunks';
import { useSocket } from 'store/chat/selectors';
import { useCurrentClass } from 'store/classes/selectors';
import { handleUpdateGoolgeGradeInBatch } from "store/googleClassRoom/thunks";
import { useResources } from 'store/resources/selectors';
import { useRubrices } from 'store/rubric/selectors';
import { handleGradeToSchoology } from 'store/schoology/thunks';
import { useClassSubmissions } from 'store/submissions/selectors';
import { useClassUsers } from 'store/userClasses/selectors';
import { useCurrentUser } from 'store/users/selectors';
import { handleListQuestionOfWorksheet } from 'store/worksheet/thunks';
import { MenuIcon } from "utils/assets/images";
import { useCollectionNotification } from 'utils/methods/firebaseNotification';
import { af_grade, checkHasAutoGrade, checkIsManualGradable, checkIsTbgTxt, getDiffConfigForStudent, isBeforTime, isGradedByTeacher } from 'utils/methods/math';
import { v4 } from 'uuid';
import assignmentImage from "../../utils/assets/images/assignment-image.png";
import openSubMissionImage from "../../utils/assets/images/open-submission-image.png";
import AssignmentDeviceModal from './AssignmentDeviceModal';
import GradebookRubric from './GradebookRubric';
import { getCoverForAssignment } from 'utils/methods/functions';
import { usePageCover } from 'components/hooks/pageCover/pageCover';
import { useAssignmentCoverTitle } from 'components/hooks/pageCover/useAssignmentCoverTitle';
import { useUserProfileConfig } from 'store/users/selectors';
import { useGradeBook } from 'components/hooks/gradeBook/useGradeBook';
import AssignmentPrintView from './AssignmentPrintView';
import { generateAssignmentPDF } from 'utils/methods/generateAssignmentPDF';
import {
    resolveAiGradingLevel,
    resolveOverallGradeForPrint,
} from 'utils/methods/assignmentPrintHeaderHelpers';

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

const Description = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 48px;

    @media screen and (max-width: 768px) {
      font-size: 11px;
    }
`;
const UserAddignmentLabel = styled.span`
    font-size: 12px;
    font-weight: 400;
    line-height: 13px;
    background: #e7edf2;
    padding: 10px;
    display: flex;
    align-items: center;

    @media screen and (max-width:768px){
        height: auto;
    }
`;
const UserSelector = styled(UserAddignmentLabel)`
    font-weight: 400;
    line-height: 18px;
    height: 30px;
    background:${p => p.active ? '#5f4c82' : '#e7edf2'};
    color:${p => p.active ? '#e7edf2' : COLOR.black100};
    box-shadow:  ${p => p.active ? "0px 0px 0px 0px #958585e0, 0px 0px 5px 0px #958585e0" : "0px 0px #fff"};
    padding: 10px;
    display: flex;
    align-items: center;
    margin: 10px;
    cursor: pointer;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    overflow-x: hidden;
    overflow-y: hidden;
    display: flex;
    height: 30px;
`;

const UserSelectorList = styled.div`
    // max-height: 300px;
      // overflow-y: scroll;
    // margin-bottom: 20px !important;
    // overflow-x: hidden;
    // min-height:150px;
    padding-bottom: 1px;

  //   @media screen and (max-width: 1100px) {
  //       // max-height: calc(100dvh - ${p => p?.checkFrame ? "317px" : "527px"} );
  //        max-height: calc(100dvh - ${p=> p.checkFrame ? "387px" : "412px"}) !important;
  //   }

  // @media screen and (max-width: 768px) {
  //       // max-height: calc(100dvh - ${p => p?.checkFrame ? "296px" : "415px"});
  //       // max-height: calc(100vh - ${p=> p.checkFrame ? "387px" : "409px"});
  //       max-height: calc(100dvh - ${p => p?.checkFrame ? "317px" : "348px"} );
  //   }

  // @media screen and (max-width: 768px) {
  //       max-height: calc(100dvh - ${p => p?.checkFrame ? "296px" : "316px"});
  //   }
`;

const Header = styled(Description)`
   color: ${COLOR.black100};
    font-size: 17px; 
    font-weight: 900;
    line-height: 28px;
    margin-bottom: 16px;
    position: absolute;
    top: 13px;
    left: 56px;
    display: flex;
    align-items: center;
    gap: 16px;

    @media screen and (max-width: 350px) {
      font-size:13px;
    }
`;

const BackText = styled.div`
   color: ${COLOR.black100};
    font-size: 15px; 
    font-weight: 600;
    line-height: 28px;
    cursor:pointer;
    display: flex;
    align-items: center;
    `;

const Image = styled.img`
    border: 1px solid ${COLOR.black800};
    width: 100%;
    height: auto;
`;

const ImageContiner = styled.div`
    background-color: transparent;
    border: none;
    flex: 1;
    outline: none;
    width: 100%;
`;



const Notification = styled.div`
    background-color: ${p => p.bgColor ? p.bgColor : lighten(0.45, '#3D5F8F')};
    border: 1px dashed ${p => p.bgColor ? p.color : '#3D5F8F'};
    border-radius: 3px;
    color: ${p => p.color ? p.color : '#3D5F8F'};
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 24px;
    padding: 8px;
`;

const Question = styled.div`
    line-height: 16px;
    margin-bottom: 16px;
`;

const Subtext = styled.span`
    color: ${COLOR.black500};
    display: block;
    font-size: 10px;
    margin: 8px 0px 4px;
    text-transform: uppercase;
`;

const Text = styled.span`
    color: ${COLOR.green100};
    font-size: 14px;
    font-weight: 600;
    line-height: 14px;
`;



const Wrapper = styled.div`
    margin: 0px auto; 
    max-width: 100%;
    padding: 0px;
    width: 100%;
`;
const AnswerWrapper = styled.div`
    display:flex;
    flex-direction:column;
`;
const Rotate = styled.span`
    align-items: center;
    display: flex;
    height: 16px;
    justify-content: center;
    margin-right: 4px;
    transform: ${p => p.open ? 'rotate(90deg)' : 'rotate(0deg)'};
    transition: all 300ms ease;
    width: 16px;
`;
const AccordianTitle = styled(Typography)`
    display:flex;
    flex-direction:row;
    align-items: center;
    justify-content:space-between;
    width:100%;
`;
const SortingButton = styled.button`
    font-size: 12px;
    border: 1px solid #c3c1c1;
    padding: 2px;
    border-radius: 5px;
    padding-left: 4px;
    padding-right: 4px;
    color: ${p => p.active ? '#3f53b7' : COLOR.black100};
    cursor: pointer;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    min-width: 90px;
    margin: 0px 2px;
`;
const NameText = styled.span`
    margin-right: 0px;
    // width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
const CategoryMenu = styled.div`
    background-color:${COLOR.tabActive};
    border-radius: 0px 12px 12px 12px;
    color: #fff;
    height: 30px;
    padding-left: 20px;
    padding-right: 2px;
    margin-top: 4px;
    font-size: 13px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    width: auto;
    max-width: 200px;

`;
const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
`;
const HeaderDownloadButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  cursor: pointer;
  margin-right: 8px;
  transition: all 0.2s;
  &:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
const MenuIconImg = styled.img`
    margin-left:10px;
    height: 16px;
    background-color: #fff;
    border-radius: 50%;
    padding: 2px;
    margin-right: 10px;
`;
const MaxPointText = styled.span`
color:${COLOR.gray100}
`;
const PreviewArea = styled.div`
  //  max-height:60vh;
  //  max-height:100vh;
   overflow: auto;
  ::-webkit-scrollbar {
    width: 10px; /* Width of the scrollbar */
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #888; 
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }

  // @media screen and (max-width: 1100px){
  //    max-height: calc(100dvh - 346px);
  // }

  // @media screen and (max-width: 768px){
  //    max-height: calc(100dvh - 334px);
  // }
`;
// 🎯 GradeEditorInput
 const GradeEditorInput = styled(Input)(({ theme }) => ({
  border: 'none',
  fontSize: '12px',
  width: '70px',
  background: 'white',
  textAlign: 'center',
  outline: 'none',
  '& input': {
    textAlign: 'center',
  },
}));

// 🎯 Accordion
 const Accordion = styled(MuiAccordion)(({ theme }) => ({
  border: '1px solid white',
  boxShadow: 'none',
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: 'auto',
  },
}));

// 🎯 AccordionSummary

const CurrentSubmission = {
  backgroundColor: '#9933ff'
}
const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
  backgroundColor: '#03989e',
  color: 'white',
  textTransform: 'capitalize',
  borderBottom: '1px solid white',
  marginBottom: -1,
  minHeight: 30,
  '&.Mui-expanded': {
    minHeight: 30,
  },
  '& .MuiAccordionSummary-content.Mui-expanded': {
    margin: '8px 0',
  },
}));


const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: '8px',
  margin: 0,
}));


const AssignmentImg = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    font-size: 20px;
    margin: 0 auto;
    margin-top: 10px;
`

const SubmissionMessage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 29px;
    font-weight: 600;
    text-align: center;
    color: #35383d;
`
const SubmissionMessages = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    height: 0px;
    font-size: 29px;
    font-weight: 600;
    text-align: center;
    color: #35383d;
`


const RotatingArrow = styled.span`
  transition: transform 0.3s ease;
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  display: inline-flex;
  align-items: center;
`;
const HeaderWrapper =  styled.div`
  display:flex;
  flex-direction:row;
  align-items:center;
  flex-wrap: wrap;
  gap: 10px;
`


const hasGradeInA_F = (val) => {
  if (typeof val === "string") {
      const hasInGrade = [{ key: 'A', value: 90 }, { key: 'B', value: 70 }, { key: 'C', value: 50 }, { key: 'D', value: 30 }, { key: 'F', value: 10 }].find(k => k.key.toLowerCase() === val.toLowerCase())
      if (hasInGrade) {
          return ({
              value: hasInGrade.value,
              hasValue: true
          })
      }
      return ({
          value: val,
          hasValue: false
      })
  } else {
      return ({
          value: val,
          hasValue: false
      })
  }

}
const isGraphicOrganizer = (submission, fallback) => {
  const check = (val) => val === "graphic_organizer";
  return check(get(submission, "assignment.activity_type")) ||
         check(get(fallback, "data.activity_type")) ||
         check(get(fallback, "activity_type"));
};
const isGraphicOrgInProgress = (submission, fallback) => {
  const answers = get(submission, "answers", []);
  const hasAnswers = Array.isArray(answers) ? answers.some((a) => a != null) : false;
  return isGraphicOrganizer(submission, fallback) &&
    !get(submission, "complete") &&
    get(submission, "retaking") &&
    hasAnswers;
};
const StudentReview = ({
    data,
    booksAllList,
    scale_1_5,
    gradebook_a_f,
    open,
    userReviewAssignment,
    returnedSubmissionIds,
    onReturnSuccess,
}) => {
  const { isAiPermissionEnabled } = useUserProfileConfig();
  const showAlert = useAlert();
    const checkFrame = usecheckIFrame();
    const currentClass = useCurrentClass();
    const tabletType = useTabletDetection();
    const currentUser = useCurrentUser()
    const inputRef = useRef()
    const inputsRefs = useRef([])
    const feedbackAudioRef = useRef()
  	const navigate = useNavigate();
    const dispatch = useDispatch();
    const resources = useResources()
    const {createCollectionNotification} = useCollectionNotification();
    // const { firestore } = useFirebase();
    // const { deleteSubmissionData } = useCollectionAutoSubmission()
    const [grade, setGrade] = useState('');
    const [feedback, setFeedback] = useState('');
    const [loading, setLoading] = useState(null);
    const [expanded, setExpanded] = React.useState(null);
    const isRubricToggleRef = useRef(false);
    const [audioFeedback, setAudioFeedback] = useState(null);
    const [updateLoading, setUpdateLoading] = useState(null);
    const [pastSubmissions, setPastSubmissions] = useState([])
    const [allFilteredUser, setAllFilteredUser] = useState([])
    const [selectedAssignment, setSelectedAssignment] = useState({})
    const [submissionsData, setSubmissionsData] = useState({})
    const [userSubmissions, setUserSubmissions] = useState(get(data, 'assignments', []));
    // const submissionStatus = useMemo(() => (get(submissionsData, "submissions") == 0 && get(submissionsData, "answers.length", 0) == 0), [submissionsData]);
    const timmerStatus = useMemo(() => Number(get(submissionsData, "timmerDuration", 0)) > 0 && get(submissionsData, "complete") && get(submissionsData, "answers.length", 0) <= get(submissionsData, "assignment.questions.length", 0), [submissionsData])
    const submissionStatus = useMemo(() => {
        const graphicOrgInProgress = isGraphicOrgInProgress(submissionsData, selectedAssignment);
        return (get(submissionsData, "submissions") == 0 && get(submissionsData, "answers.length", 0) == 0) && !(submissionsData?.graded && !submissionsData?.isTemp) && !graphicOrgInProgress;
    }, [submissionsData, selectedAssignment]);
    const inProgressSatatus = useMemo(() => (
        isGraphicOrgInProgress(submissionsData, selectedAssignment) ||
        (!get(submissionsData, "complete") && get(submissionsData, "retaking") && get(submissionsData, "assignment.questions.length", 0) > get(submissionsData, "assignment.answers.length", 0))
    ), [submissionsData, selectedAssignment]);
    const assignment_grade_value = useMemo(()=>getAssignmentGradeValue(submissionsData, selectedAssignment, isAiPermissionEnabled),[submissionsData, selectedAssignment, isAiPermissionEnabled])
    const selected_assignment_tbg =  checkIsTbgTxt(assignment_grade_value)
    const is_graphic_organizer_assignment = isGraphicOrganizer(submissionsData, selectedAssignment)
    const current_assignment_returned  = useMemo(()=>isReturned(submissionsData),[submissionsData])
    const rubrics = useRubrices()
  const assignmentRubrics = useMemo(() => {
    const diffConf = getDiffConfigForStudent(get(selectedAssignment, "submissions.userId"), selectedAssignment, get(currentClass, "id"))
    const diff_rubrics = diffConf ? diffConf.rubrics_id : null
    const rubrics_id = diff_rubrics || selectedAssignment?.rubrics_id;
    return rubrics_id ? find(rubrics, ['id', rubrics_id]) : null
  }, [rubrics, selectedAssignment, currentClass])
    const currentSubmissionRubric = get(selectedAssignment, "submissions.rubrics_data", []);
    const [assignmentshow, setAssignmentshow] = useState(false);
    const userInfo = get(data, 'user', '');
    const is_user_not_active  =  get(data,"user.userclass.active",true)
    const [select,setSelect]=useState("All")
    const [modalOpen, setModalOpen] = useState(false);
    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1024);
    const [is_mobile_menu,setMobileMenu] = useState(false);
    const pdfContentRef = useRef();
    const [pdfData, setPdfData] = useState({
        pdfQuestions: [],
        pdfAnswers: [],
        pdfStudentName: '',
        pdfClassName: '',
        pdfActivityTitle: '',
        pdfAiGrades: [],
        pdfAiFeedbacks: [],
        pdfAiSuggestions: [],
        pdfOverallGrade: '',
        pdfProficiencyLevel: '',
    });
    const [generatingPDFForId, setGeneratingPDFForId] = useState(null);
    const [sizes, setSizes] = useState([600,500]);
    const orientation = useOrientation();
    const [isOpen, setIsOpen] = useState(false);
    const all_submissions = useClassSubmissions()
    const studentSubmissionsRef = useRef(groupBy(all_submissions, 'userId')||{})
    const [questions, setQuestions] = useState({})
    const [loadingQuestions, setloadingQuestions] = useState(false)
    const [refreshLoading, setRefreshLoading] = useState(false)
    const [trackingLogId, setTrackingLogId] = useState(null);
    const [trackingSubmissionLabel, setTrackingSubmissionLabel] = useState('');
    const is_feedback_input_active = useRef(false);
    const assignedStudentList = useMemo(() => {
      const currentClassData = selectedAssignment?.classes?.find((cls) => cls.id === currentClass?.id);
      if(currentClassData && Object.keys(currentClassData).length > 0){
        const currentClassUsers = currentClassData?.users || [];
        if(currentClassUsers?.length > 0){
          const checkCurrentUserAssigned = currentClassUsers.includes(get(data, "user.id"));
          return checkCurrentUserAssigned
        }else{
          return true;
        }
      }else{
        return true;
      }
    }, [data,selectedAssignment,currentClass])
    const { getGradeWithPreference, isDoneLateSubmission, getMarkStatus, getMarkStatusBingo, getSubmissionStatus, hasValidAiFeedback } = useGradeBook();



    useEffect(()=>{
        if(all_submissions?.length){
            const studentSubmissions = groupBy(all_submissions, 'userId')||{}
            studentSubmissionsRef.current = studentSubmissions
        }

    },[all_submissions])

    const [alertSakeBar, setAlertSakeBar] = useState({
        open: false,
        message: "",
        severity: "error",
    });
    const closeStudentTrackingModal = useCallback(() => {
        setTrackingLogId(null);
        setTrackingSubmissionLabel('');
    }, []);
    const trackingLogSources = useMemo(
        () => buildTrackingLogSources(pastSubmissions, submissionsData),
        [pastSubmissions, submissionsData]
    );
    const handleDropdownVisibleChange = (visible) => {
      setIsOpen(visible);
    };
  const fetchData = async (id) => {
    try {
      const val = questions[id];
      const has_data = val && Array.isArray(val) && val.length > 0
      setloadingQuestions(!has_data);
      const response = await dispatch(handleListQuestionOfWorksheet(id));
      if (Array.isArray(response) && response.length > 0) {
        setQuestions(k => ({
          ...k,
          [id]: response
        }));
      } else {
        setQuestions(k => ({
          ...k,
          [id]: []
        }));
        showAlert("No questions found for this worksheet.", "warning")
      }
    } catch (error) {
    } finally {
      setloadingQuestions(false)
    }
  };
  useEffect(() => {
    if (selectedAssignment && selectedAssignment.data && selectedAssignment.data.typeId) {
      const is_worksheet = selectedAssignment.data.typeId === "worksheet";
      const worksheet_id = selectedAssignment.game_id;
      if (worksheet_id && is_worksheet) {
        fetchData(worksheet_id)
      }
    }
  }, [selectedAssignment])
    useEffect(() => {
        const onResize = () => {
            if (window.innerWidth >= 1100) {
                setMobileMenu(false);
            } else if (window.innerWidth < 1100) {
                setMobileMenu(true);
            }
        }
        onResize();
        window.addEventListener('resize', onResize);

        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, [orientation]);
    const classUsers = useClassUsers()

    // useEffect(() => {
    //     const unsubscribe = listenToAutoSubmission();
    //     return () => {
    //         unsubscribe();
    //     };
    // }, [firestore, data, selectedAssignmentChange])

    // const listenToAutoSubmission = () => {
    //     const userAssignments = get(data, 'assignments', [])
    //     const submissionDocId = get(selectedAssignmentChange, "data.id") + get(data, "user.id");
    //     const collectionRef = collection(firestore, "auto_submission");
    //     const q = query(collectionRef,
    //         where("submissionId", "==", submissionDocId),
    //     );
    //     const unsubscribe = onSnapshot(q, (querySnapshot) => {
    //         querySnapshot.forEach((doc) => {
    //             const autoSubmission = doc.data();
    //             const docId = doc?.id;
    //             const autoReceiveData = autoSubmission?.submissionData || {};
    //             let newUserSubmission = []
    //             if (userAssignments?.length > 0) {
    //                 newUserSubmission = userAssignments.map(submission => {
    //                     if (submission?.data?.id === autoReceiveData?.assignment?.id) {
    //                         return {
    //                             ...submission,
    //                             submissions: autoReceiveData
    //                         };
    //                     }
    //                     return submission;
    //                 });
    //             } else {
    //                 newUserSubmission = [...userAssignments, autoReceiveData];
    //             }
    //             const newUserSubmissionIndex = newUserSubmission.findIndex(item => item?.data?.id === autoReceiveData?.assignment?.id);
    //             newUserSubmission[newUserSubmissionIndex].isPreview = selectedAssignment?.isPreview ? true : false;
    //             newUserSubmission[newUserSubmissionIndex].isShowRubric = selectedAssignment?.isShowRubric ? true : false;
    //             setSelectedAssignment(newUserSubmission[newUserSubmissionIndex])
    //             setUserSubmissions(newUserSubmission)
    //             if (autoSubmission?.status) {
    //                 deleteSubmissionData(docId)
    //                 return;
    //             }
    //         });
    //     }, (error) => {
    //         console.error("Error listening to session changes:", error);
    //     });
    //     return unsubscribe;
    // }
    const getUserName = (usr) => {
        const first_name = get(usr, "firstName", "");
        const last_name = get(usr, "lastName", "");
        return <NameText className='text-wrap'>{first_name} {last_name}</NameText>
    }
      const categoryAllStudent = () => {
        return {
          items: map(data?.class_users, (ct, index) => {
            if(!ct?.userclass?.active || !ct?.active){
              return null;
          }
            return ({
            key: index,
            label: (
              <PaddedBtn
                onClick={() => {
                  if(userReviewAssignment && typeof userReviewAssignment === "function"){
                    userReviewAssignment(ct, data.assignment);
                  }
                }}
              >
                {getUserName(ct)}
              </PaddedBtn>
            ),
            style: { padding: "0px" }
          })}),
          style: { maxHeight: '200px', overflowY: 'auto' }
        };
    };
    
  const SelectedUserDropDown = useCallback(() => {
    const handleTouchStart = (e) => {
      e.preventDefault();  // Prevent default touch behavior
    };
    return (
      <div className='selectedUser' style={{
        height: "auto", width: "100%", touchAction: 'manipulation',  // Improves touch handling
        cursor: 'pointer'
      }}>
        <Dropdown onOpenChange={handleDropdownVisibleChange} menu={categoryAllStudent()} placement="bottomLeft" trigger={['click', 'touch']} getPopupContainer={(trigger) => trigger.parentNode} overlayClassName="optionsListMenuEbook">
          <CategoryMenu style={{ fontSize: "12px", height: "24px" }} className='text-wrap d-flex w-full' onTouchStart={handleTouchStart}>
            <span style={{ maxWidth: "160px" }} className='text-wrap'>
              {get(data?.user, "firstName", "")}{" "}
              {get(data?.user, "lastName", "")}
            </span>

            <RotatingArrow isOpen={isOpen}>
              <KeyboardArrowDownOutlined />
            </RotatingArrow>
          </CategoryMenu>
        </Dropdown>
      </div>
    )
  },[data])
  useEffect(() => {
    if (userSubmissions && (typeof selectedAssignment == "object" && Object.keys(selectedAssignment).length > 0)) {
      const dataIndex = userSubmissions.findIndex(v => v && v.data && v.data.id && v.data.id == selectedAssignment?.data?.id)
      if (!(dataIndex >= 0)) return
      const k = userSubmissions[dataIndex];
      if (k) {
        setData(k);
        setSelectedAssignment(prev => {
          const data = { ...prev }
          data.isPreview = true;
          return data;
        })
      }
    }
  }, [is_mobile_menu, userSubmissions])
    useEffect(() => {
        const previousAssignmentId = get(selectedAssignment, "data.id");
        const newUserSubmissions = get(data, 'assignments', []);
        setUserSubmissions(newUserSubmissions);
        setAllFilteredUser(newUserSubmissions);
        
        if (previousAssignmentId && newUserSubmissions.length > 0) {
            const sameAssignment = newUserSubmissions.find(sub => get(sub, "data.id") === previousAssignmentId);
            if (sameAssignment) {
                const userSub = { ...sameAssignment };
                userSub.isPreview = selectedAssignment?.isPreview || false;
                setSelectedAssignment(userSub);
                return;
            }
        }
        
        const userSub = newUserSubmissions[0] || {};
        userSub.isPreview = false;
        setSelectedAssignment(userSub);
    }, [data])

    useEffect(() => {
        const handleResize = () => {
          setIsLargeScreen(window.innerWidth >= 1024);
        };
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);

    useEffect(() => {
        if (!assignmentRubrics && assignmentshow) {
            setAssignmentshow(false);
        }
    }, [assignmentRubrics])
    useEffect(() => {
        let submissionData = get(selectedAssignment, "submissions", {})
        const grade_type = get(selectedAssignment, "grade_type")
        const isPointSystem = grade_type === "points"
        const face_grade  = submissionData.face_grade?submissionData.face_grade:null
        
        setSubmissionsData(submissionData)
        const grade = getGradeval(submissionData)
        setPastSubmissions(getpastSubmissions(submissionData))
        const is_game = get(submissionData, "assignment.typeId", '') === "game"
        const is_debate = get(submissionData, "assignment.typeId", '') === "debate"
        const is_worksheet = get(submissionData, "assignment.typeId", '') === "worksheet"
        const is_loteria = get(submissionData, "assignment.typeId", '') === "bingo"
        const questions =  get(submissionData, "assignment.questions", [])
        const isCompleteTbg = checkIsManualGradable(questions) && !checkHasAutoGrade(questions)
        const is_ai_graded = submissionData?.ai_grade?.length > 0;
        let expected_grade = isPointSystem ? face_grade : grade;
        const has_not_graded = is_ai_graded ? false : (isCompleteTbg && !is_game && !is_loteria && !is_debate && !is_worksheet) && !expected_grade && submissionData?.manualGrading && submissionData?.complete;
        expected_grade =((expected_grade==0||expected_grade>0)||(typeof expected_grade ==="string" && expected_grade.length>0))? expected_grade:''
        const grd =submissionData?.complete?( has_not_graded || !submissionData || !submissionData.id?'':expected_grade):''
        setGrade(grd);
        setFeedback(submissionData?.feedback || '');
        setAudioFeedback(submissionData?.audioFeedback || null);
        if (feedbackAudioRef.current) {
            feedbackAudioRef.current.reset()
            feedbackAudioRef.current.setAudio(submissionData?.audioFeedback)
        }
        const submissionId = get(submissionData, 'id');
        const previousSubmissionId = get(submissionsData, 'id');
        if (isRubricToggleRef.current) {
            isRubricToggleRef.current = false;
        } else {
            if (submissionId && submissionId !== previousSubmissionId) {
                setExpanded(submissionId);
            } else if (submissionId && !expanded) {
                setExpanded(submissionId);
            }
        }
    }, [selectedAssignment])

    function getGradeval  (dt)  {
        let grade = get(dt, "grade");
        if (scale_1_5) {
            if (!isNaN(grade)) {
                let _g = grade <= 0 ? 0 : floor((grade - 1) / 20)
                grade = (_g > 4 ? 4 : Math.floor(_g)).toString();
            }
        }
        else if (gradebook_a_f) {
            if (grade !== "NaN") {
              const isTemp = get(dt, "isTemp")
              const isGraded = get(dt, "graded")
              
              if ((isGraded && isTemp) || !isGraded) return '-'
              grade = af_grade(grade);
            }
            else {
                grade = "-";
            }
        }
        return grade;
    }
    const getpastSubmissions = (dt) => {
        const p_submission = get(dt, "pastSubmissions", []).sort((a, b) => parseInt(a.createdAt) - parseInt(b.createdAt))
        const returnedAtNumbers = (get(dt, "returned_at") || []).map(num => parseInt(num));
        const p_grouped = p_submission.reduce((acc, sub) => {
            const submissionNum = parseInt(sub.submissions);
            if (!acc[submissionNum]) {
                acc[submissionNum] = [];
            }
            acc[submissionNum].push(sub);
            return acc;
        }, {});
        const filtered = Object.values(p_grouped).flatMap((group) => {
            const hasNonEmptyAnswers = group.some(sub => Array.isArray(sub.answers) && sub.answers.length > 0);
            if (hasNonEmptyAnswers && !returnedAtNumbers.includes(parseInt(group[0].submissions))) {
                return group.filter(sub => Array.isArray(sub.answers) && sub.answers.length > 0);
            }
            return group;
        });
        const sorted = filtered.sort((a, b) => parseInt(a.submissions) - parseInt(b.submissions));
        const return_data =  sorted.map((k, i) => {
            let is_return = returnedAtNumbers.includes(parseInt(k.submissions));
            const nextSubmission = sorted[i + 1]
            if (nextSubmission && nextSubmission.submissions === k.submissions) {
                is_return = false;
            }
            return ({ ...k, is_return })
        })
        return return_data
    }
    function  isReturned (submission)  {
        return  submission && Object.keys(submission || {}).length > 0 && parseInt(get(submission, "submissions")) == (parseInt(get(submission, "returned", 0)) - 1)
    }
    const getStatus = (dt, assignmentFallback = selectedAssignment) => {
        const exception = get(dt, "exceptionStatus");
        const createAt = get(dt, "createdAt")
        const complete = get(dt, "complete")
        const isTemp = get(dt, "isTemp")
        // const isProgress = (!get(dt, "complete") && get(dt, "retaking") && dt?.assignmentType === "worksheet" ? get(dt, "id") : get(dt, "assignment.questions.length", 0) > get(dt, "assignment.answers.length", 0));
        const isProgress = getSubmissionStatus(dt).inProgressStatus || isGraphicOrgInProgress(dt, assignmentFallback);
        const isGradedByTeacher = get(dt, "submissions") == 0 && get(dt, "answers.length", 0) == 0 && get(dt, "pastSubmissions.length", 0) == 0
        const grade = getGradeval(dt)
        if (exception > 0) {
            if (exception == 1) {
                return <span>{get(currentUser, "schoologyid") ? "Exempt" : "Excused"}</span>
            } else if (exception == 2) {
                return <span> Incomplete</span>
            } else if (exception == 3) {
                // return <span style={{ color: COLORSTATUS[exception] }}> Missing</span>
                return <span> Missing</span>
            } else if (exception == 5) {
                // return <span style={{ color: COLORSTATUS[exception] }}> Missing</span>
                return <span> Absent</span>
            } else if (exception == 6) {
                // return <span style={{ color: COLORSTATUS[exception] }}> Missing</span>
                return <span> Late</span>
            }
        } else if (isGradedByTeacher && !isTemp && grade > 0) {
            return "Graded Without Submission"
        }
        else if (isProgress) {
            return "In progress"
        }
        else if (complete && createAt) {
            return `Completed on ${moment(parseInt(createAt)).format('MMM DD, YYYY hh:mm A')}`;
        } else if (createAt && !isTemp) {
            return `${moment(parseInt(createAt)).format('MMM DD, YYYY hh:mm A')}`;
        } else {
            return "Not submitted."
        }
    }
  const getAssignmentDueOn = useCallback(() => {
    if (!selectedAssignment) return '';
    const userId = selectedAssignment?.submissions?.userId;
    const diff = getDiffConfigForStudent(userId, selectedAssignment, currentClass.id)
    if (diff) {
      return `${moment(diff.dueDateDif).format('MMM DD, YYYY hh:mm A')}`
    } else {
      return `${moment(selectedAssignment.dueDate).format('MMM DD, YYYY hh:mm A')}`
    }
  }, [selectedAssignment, currentClass])
    const isDueDatePassed = (assignment) => {
        if (!assignment) return false;
        const classConfig = find(assignment.classes, ['id', currentClass?.id]);
        const diffConfig =  getConfigForDiff(classConfig,userInfo?.id)
        if (diffConfig.dueDateDif) {
            return isBeforTime(diffConfig.dueDateDif);
        } else {
            return assignment.lateDate ? isBeforTime(assignment.lateDate) : isBeforTime(assignment.dueDate);
        }
    };
    const getCompleteInclompleteMark = (isComplete, isInComplete, isActive, assignment) => {
        const isPastDue = isDueDatePassed(assignment)
        if (isComplete) {
            return <Check style={{ color: isActive ? COLOR.white : COLOR.green100, fontSize: 18 }} />
        } else if (isInComplete || isPastDue) {
            return <Close style={{ color: isActive ? COLOR.white : COLOR.red, fontSize: 18 }} />
        } else {
            return <span style={{ color: isActive ? COLOR.white : COLOR.gray100, fontSize: 18 }}  >-</span>
        }
  }
  function getAssignmentGradeValue(dt, assignment, isAiPermissionEnabled) {
    if(!dt) return '-'
    const questions = get(dt, "assignment.questions", []);
    const isTbg =  checkIsManualGradable(questions);
    const assignmentMeta = assignment || selectedAssignment;
    const is_graphic_organizer = isGraphicOrganizer(dt, assignmentMeta);
    let tbg_text;
    if (currentUser?.role === 'student') {
      tbg_text = 'TBG';
    } else {
      tbg_text = is_graphic_organizer ? "TBG" : (isAiPermissionEnabled ? "TBG - AI" : "TBG");
      // tbg_text = dt&&dt.ai_grade&&dt.ai_grade?.length > 0?"TBG - AI": "TBG";
    }
    const tbgTxt = isTbg ? tbg_text : "-";
    const manualGrading = get(dt, "manualGrading", false);
    const retaking = get(dt, "retaking", false);
    const isTemp = get(dt, "isTemp");
    const grade = getGradeval(dt);
    const face_grade = get(dt, "face_grade")
     const complete = typeof dt.complete === "boolean"?dt.complete:true;
     if(!complete) return '-'
    const grade_type = assignment ? get(assignment, "grade_type") : get(selectedAssignment, "grade_type")
      const is_ai_graded = dt?.ai_grade?.length > 0;
    let val = grade;
    if (hasGradeInA_F(grade).hasValue) {
      val = grade;
    } else if (isTemp || (!is_ai_graded && retaking && grade === 0)) {
      val = "-";
    } else if (grade > 0 || grade == 0) {
      val = grade;
    } else {
      val = "-";
    }
    if (grade_type === "points") {
      if (isTbg && manualGrading) {
        return (face_grade == 0 || face_grade >  0)? `${face_grade} (${tbgTxt})` : tbg_text;
      } else {
        return (face_grade == 0 || face_grade > 0) ? face_grade : '-'
      }
    } else {
      if (isTbg && manualGrading) {
        return ( (val || val === 0) )? `${val} (${tbgTxt})` : tbg_text;
      } else {
        return val;
      }
    }

    }
    const setData = (dt) => {
        setSelectedAssignment(dt)
    }
  

    const filterStudentList = (key) => {
        setSelect(key)
        let val = null;
        switch (key) {
            case "All":
                setUserSubmissions(allFilteredUser)
                break;
            case "Missing":
                val = filter(allFilteredUser, obj => obj.submissions?.exceptionStatus == 3);
                setUserSubmissions(val)
                break;
            case "Incomplete":
                val = filter(allFilteredUser, obj => obj.submissions?.exceptionStatus == 2);
                setUserSubmissions(val)
                break;
            case "Excused":
                val = filter(allFilteredUser, obj => obj.submissions?.exceptionStatus == 1);
                setUserSubmissions(val)
                break;
            case "Absent":
                val = filter(allFilteredUser, obj => obj.submissions?.exceptionStatus == 5);
                setUserSubmissions(val)
                break;
            case "Late":
                val = filter(allFilteredUser, obj => obj.submissions?.exceptionStatus == 6);
                setUserSubmissions(val)
                break;
            case "Returned":
                val = filter(allFilteredUser, obj => (obj?.returned > 0 && obj?.submissions == (obj?.returned - 1)));
                setUserSubmissions(val)
                break;
            default:
                break;
        }
    }
    const handleFeedback = (e) => {
        setFeedback(e.target.value);
    };
    const onBlurInput = () => {
        document.activeElement.blur();
    }
  const onEnterPress = () => {
    if (assignmentshow) return;
    try {
      const activeIndex = findIndex(userSubmissions, e => get(selectedAssignment, "id") == get(e, "id"))
      const hasref = inputsRefs.current.find(e => e == document.activeElement)
      if (!hasref) {
        if (inputsRefs.current[activeIndex]) {
          inputsRefs.current[activeIndex].focus();
          inputsRefs.current[activeIndex].select();
        }
      } else {
        if (inputRef.current === document.activeElement) {
          return false;
        }
        onBlurInput()
        if (activeIndex < userSubmissions.length && userSubmissions[activeIndex + 1]) {
          setData(userSubmissions[activeIndex + 1])
          if(inputsRefs.current[activeIndex + 1]) {
            inputsRefs.current[activeIndex + 1].focus();
            inputsRefs.current[activeIndex + 1].select();
          }
        }
      }
    } catch (error) {
      Sentry.captureException(`601 Error in onEnterPress: ${error}`);
      console.log(error, "error in enter");
    }
  }
    const handleKeyDown = useCallback((e) => {
        const activeIndex = findIndex(userSubmissions, e => get(selectedAssignment, "id") == get(e, "id"))
        if(is_feedback_input_active.current) return;
        if (activeIndex < 0 || !userSubmissions) return;
        const { key } = e;
        switch (key) {
            case "ArrowUp":
            case 38:
                if(assignmentshow) return;
                if (activeIndex > 0 && userSubmissions[activeIndex - 1]) {
                    setData(userSubmissions[activeIndex - 1])
                    onBlurInput()
                }

                break;
            case "ArrowDown":
            case 40:
               if(assignmentshow) return;
                if (activeIndex < userSubmissions.length && userSubmissions[activeIndex + 1]) {
                    setData(userSubmissions[activeIndex + 1])
                    onBlurInput()
                }
                break;
            case "Enter":
            case 13:
              onEnterPress();
              break;
            default:
                break;
        }
    }, [userSubmissions, selectedAssignment])
    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };

    }, [handleKeyDown]);
    const handleFocus = (event) => event.target.select();

    const handleSubmit = async (e, audioFeedbackUrl, updateAndClose, v, feedBackText , assignment , gradeMarking) => {
        const grade_type = get(assignment, "grade_type")
        const max_point = assignment?.max_point && !isNaN(assignment?.max_point) ? Number.parseInt(assignment.max_point, 10) : 100
        const isPointSystem = grade_type === "points"

        if (e) {
            e.preventDefault();
        }   
        const has_feedback =  audioFeedbackUrl || feedBackText
        let val =  v ? v : grade;
        if(!val&&val!=0&&!has_feedback)return;
        let tempGrade = v ? v : grade;
        if (scale_1_5 && tempGrade <= 4) {
          tempGrade = tempGrade == 0 ? tempGrade : `${(tempGrade * 20) + 10}`
          val = isPointSystem ? val : tempGrade
        }
         if (gradebook_a_f && hasGradeInA_F(tempGrade).hasValue) {
          tempGrade = hasGradeInA_F(tempGrade).value;
          val = isPointSystem ? val : tempGrade
        }
        let tempData = { ...submissionsData }
        const notificationData = {
            id: v4(),
            classId: get(currentClass, 'id', ''),
            displayName: get(assignment, 'displayName', ''),
            senderId: get(currentUser, 'id', ''),
            receiversId: [].concat(get(tempData, 'userId', '')),
            modified: moment().toISOString(),
            data: {
                chapter: get(tempData, 'assignment.chapter', ''),
                page: get(tempData, 'assignment.page', ''),
                id: get(tempData, 'assignment.id', ''),
                assignmentType: get(tempData, 'assignmentType', '') || '',
            },
            message: `Your Teacher Graded this ${get(tempData, 'assignmentType', '') === 'debate' ? 'Debate' : get(tempData, 'assignmentType', '') === 'game' ? 'Game' : get(tempData, 'assignmentType', '') === 'bingo' ? 'Bingo' : 'Assignment'}`,
            type: 'update_grade',
            userSeen: []
        }
        // if ((tempGrade == submissionsData?.grade&&!get(submissionsData,"manualGrading",true))&& !audioFeedbackUrl && !feedBackText) {
        if (((tempGrade == submissionsData?.grade && !get(submissionsData, "manualGrading", true)) && !audioFeedbackUrl && !feedBackText) || (submissionsData.isTemp && tempGrade == 0)) {
            return;
        }
        setLoading(updateAndClose ? "uc" : "u");
        sendNotifications(notificationData);
        if (has(assignment, "id") || selectedAssignment) {
            setUpdateLoading(assignment?.id || selectedAssignment.id)
        }
        if (isPointSystem) {
            const per = (val / max_point) * 100;
            tempGrade = per;
        }
        if (!has_feedback) {
            updateGradeToCanvas(isPointSystem ? val : tempGrade)
            updateGradetoGoogleClassRoom(isPointSystem ? val : tempGrade);
        }
        const schoologyFeedbackText = feedBackText || feedback;
        updateGradetoSchoology(isPointSystem ? val : tempGrade, {
            feedbackText: has_feedback && schoologyFeedbackText ? schoologyFeedbackText : undefined,
            manualGrading: has_feedback ? submissionsData?.manualGrading : undefined,
        });
        if (!submissionsData || !submissionsData.id) {
            tempData["grade"] = tempGrade;
            tempData["feedback"] = feedBackText ? feedBackText : feedback;
            tempData["audioFeedback"] = audioFeedbackUrl ? audioFeedbackUrl : audioFeedback;
            tempData["complete"] = false;
            tempData["answers"] = [];
            tempData["graded"] = true;
            tempData["submissions"] = 1;
            tempData["rubrics_data"] =  gradeMarking || {}
        }
        tempData.face_grade = val;
        let submissions = null;
        if (get(submissionsData, "id")) {
            const isInProgress = !submissionsData.complete && submissionsData.retaking;
            let submissionCount = submissionsData.submissions || 0;
            if (isInProgress) {
                submissionCount = isNaN(submissionCount) ? 1 : parseInt(submissionCount, 10) + 1;
            }
            const dt = {
                id: submissionsData.id,
                grade: has_feedback&&submissionsData.manualGrading?submissionsData.grade :  tempGrade,
                audioFeedback: audioFeedbackUrl ? audioFeedbackUrl : audioFeedback,
                feedback: feedBackText ? feedBackText : feedback,
                face_grade: has_feedback&&submissionsData.manualGrading?submissionsData.face_grade:val,
                manualGrading: has_feedback ? submissionsData.manualGrading : false,
                graded_by_teacher:has_feedback&&submissionsData.manualGrading?false:true,
                rubrics_data : gradeMarking || {},
                submissions: isInProgress ? submissionCount : undefined
            }
            submissions = await dispatch(handleUpdateGrade(dt))
        } else {
            submissions = await (dispatch(handleUpdateSubmission(get(submissionsData, "id"), {
                answers: submissionsData.answers,
                complete: submissionsData.complete,
                grade: tempGrade,
                submissions: submissionsData.submissions,
                retaking: false,
                graded: true,
                feedback: feedBackText ? feedBackText : feedback,
                audioFeedback: audioFeedbackUrl ? audioFeedbackUrl : audioFeedback,
                manualGrading: audioFeedbackUrl ? submissionsData.manualGrading : false,
                face_grade:val,
                rubrics_data : gradeMarking || {}
            }, tempData)))
        }
        setGrade(tempGrade)
        setLoading(null);
        setUpdateLoading(null);
        if (submissions) {
          const updateStudentData = map(userSubmissions, k => {
            if (submissions.assignmentId == get(k, "data.id") || submissions.id == k?.submissions?.id) {
              return ({
                ...k, submissions: {
                  ...k.submissions,
                  ...submissions,
                  face_grade:val,
                  grade:tempGrade,
                  graded: true,
                  isTemp: false
                }, 
                isTemp: false, isPreview: false
              })
            } else {
              return k;
            }
          })
          const allFilteredUserData = map(allFilteredUser, k => {
            if (submissions.assignmentId == get(k, "data.id") || submissions.id == k?.submissions?.id) {
              return ({
                ...k, submissions: {
                  ...submissions,
                  face_grade:val,
                  grade:tempGrade,
                  graded: true,
                  isTemp: false
                }, isTemp: false, isPreview: false
              })
            } else {
              return k;
            }
          })

          setAllFilteredUser(allFilteredUserData)
          setUserSubmissions(updateStudentData)
        }
    }
    const sendNotifications = async (notificationData) => {
        try {
            createCollectionNotification(notificationData, get(currentClass, 'id', ''));
        } catch (error) {
            Sentry.captureException(`602 Error in sendNotifications: ${error}`);
            console.log(error, "error")
        }
    }



    const handleChange = (e) => {
        let _value = e.target.value.replace(/-/g, '');
        if(_value === '-') return;
        if (_value.startsWith('0') && _value.length > 1) {
          setGrade('0');
          return;
        }
        const grade_type = get(selectedAssignment, "grade_type")
        const max_point = get(selectedAssignment, "max_point") >= 0 ? get(selectedAssignment, "max_point", 100) : 100
        const isPointSystem = grade_type === "points"
        const af = hasGradeInA_F(_value)
        const isAf = af.hasValue && !!gradebook_a_f;
        const isScale = scale_1_5 && _value <= 4 && _value >= 0
        const isAv = !scale_1_5 && !gradebook_a_f && _value <= 100 && _value >= 0
        if (isPointSystem) {
            if (_value >= 0 && _value <= max_point) {
                setGrade(_value);
            }
        }
        else if (isScale || isAf || isAv || _value === "")
            setGrade(_value);
        //    onChangeUpdate(_value)
    };

    const handleGradeFieldKeyDown = (e) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        const isUpdateDisabled =
            !isValidFeedback ||
            loading ||
            updateLoading ||
            grade === '-' ||
            grade === '' ||
            grade === null ||
            !assignedStudentList;
        if (isUpdateDisabled) return;
        const gradeInput = e.target?.value ?? grade;
        if (gradeInput === '' || gradeInput === null || gradeInput === '-') return;
        handleSubmit(e, null, false, gradeInput, null, selectedAssignment);
    };

    const updateGradeToCanvas = async (_val) => {
        if (currentUser && currentUser.canvas_id && currentClass.canvas_id) {
            const assignment = selectedAssignment;
            let assignmentId = assignment?.canvas_id
            if(assignmentId){
                await handleUpdateCanvasGradeInBatch(currentUser.canvas_id,{
                    "canvas_assignment_id": assignmentId,
                    "course_id":currentClass.canvas_course_id,
                    "canvas_user_id":get(find(classUsers,["id",get(userInfo,"id")]),"canvas_id"),
                    "grade": _val
                }, currentUser.canvas_auth_id)
            }
        }
    }
    const updateGradetoGoogleClassRoom = async (_val) => {
        if (currentClass && currentClass.googleId) {
            try {
                const assignmentId = get(selectedAssignment,"googleId");
                const studentGoogleId = get(find(classUsers,["id",get(userInfo,"id")]),"googleId")
                if(assignmentId){
                    await handleUpdateGoolgeGradeInBatch(currentUser.googleId,studentGoogleId,currentClass.googleId,assignmentId,_val)
                }

            } catch (error) {
                Sentry.captureException(`604 Error in updateGradetoGoogleClassRoom: ${error}`);
                console.log(error, "issue in update grade to classroom");
            }
        }
    }
    const updateGradetoSchoology = async(_val, { feedbackText, manualGrading } = {}) => {
        const userInfoData = find(classUsers,["id",get(userInfo,"id")]);
        const schoologyid =  get(userInfoData,"schoologyid");
        const sAssignmentId = get(selectedAssignment,"sAssignmentId");
        const classSectionId = get(currentClass,"sectionId");
        if (schoologyid && sAssignmentId && classSectionId) {
            await handleGradeToSchoology({
                sectionId: classSectionId,
                schoologyid: currentUser.schoologyid,
                statusCode: null,
                value: _val,
                studentSchoologyIds: [schoologyid],
                sAssignmentId: sAssignmentId,
                manualGrading,
                feedbackText
            })
        }
    }
    const handleChangeExpend = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : null);
        if (newExpanded) {
            setAssignmentshow(false);
        }
    };

    const getTBGPoint = (assign) => {
      const value = getAssignmentGradeValue(assign, isAiPermissionEnabled)
      const max_point =  get(selectedAssignment, "max_point")>=0? get(selectedAssignment, "max_point",100):100
      return `${value}/${max_point}`
    }
    const getHigestMark = (assign, isAiPermissionEnabled) => {
        if (!assign) return ({ isHighest: false, val: '', progress: false })
        const assigneGrade = get(assign, "grade", 0)
        const submissionGrade = get(submissionsData, "grade", 0)
        const isCurrentAssign = get(assign, "id") === get(submissionsData, "id");
        const inProgress =
            (isCurrentAssign && isGraphicOrgInProgress(submissionsData, selectedAssignment)) ||
            (!get(assign, "complete") && get(assign, "retaking") && get(submissionsData, "assignment.questions.length", 0) > get(assign, "assignment.answers.length", 0));
        const assignVal = getAssignmentGradeValue(assign, selectedAssignment, isAiPermissionEnabled)
        const grade_type = get(selectedAssignment, "grade_type")
        const isPointSystem = grade_type === "points"
        let highest = assigneGrade;
        map(pastSubmissions, pt => {
            if ((get(pt, "grade", 0) > highest)) {
                let val = getAssignmentGradeValue(pt, selectedAssignment, isAiPermissionEnabled)
                if (!checkIsTbgTxt(val)) {
                    highest = get(pt, "grade", 0);
                }
            }
        })
        if ((submissionGrade > highest) && !inProgress) {
            if (!checkIsTbgTxt(assignVal)) {
                highest = submissionGrade;
            }
        }
        if ((highest > get(assign, "grade", 0)) || inProgress) {
            return ({ isHighest: false, val: isPointSystem ? getTBGPoint(assign) : getAssignmentGradeValue(assign, selectedAssignment, isAiPermissionEnabled), progress: isCurrentAssign && inProgress })
        } else {
            let val = isPointSystem ? getTBGPoint(assign)  : getAssignmentGradeValue(assign, selectedAssignment, isAiPermissionEnabled)
            return ({ isHighest: !checkIsTbgTxt(val) && val != 0, val: val, progress: false })
        }
    }
    const getDisplayName = useCallback((data) => {
      if (data) {
        if (selectedAssignment) return selectedAssignment.displayName
        return data.displayName || data.data?.displayName;
      }
      return ''
    }, [selectedAssignment])
    const handleDownloadPDF = useCallback(async (submissionQuestions, submissionAnswers, submissionId, submissionNumber, submissionForAi) => {
        setGeneratingPDFForId(submissionId);
        const studentName = [get(userInfo, 'firstName', ''), get(userInfo, 'lastName', '')]
            .filter(Boolean)
            .join(' ')
            .trim();
        const assignmentDisplayName =
            getDisplayName(submissionsData) || get(selectedAssignment, 'displayName', '');
        const className = get(currentClass, 'displayName', '');
        const isunGraded = get(selectedAssignment, 'ungraded');
        const isReturnedForHeader =
            submissionForAi?.returned > 0 &&
            submissionForAi?.submissions === (submissionForAi?.returned - 1);
        const isCurrentSubmission = get(submissionForAi, 'id') === get(submissionsData, 'id');
        const gradeProp = isCurrentSubmission
            ? (grade || getAssignmentGradeValue(submissionForAi, selectedAssignment, isAiPermissionEnabled))
            : getGradeWithPreference(submissionForAi, get(selectedAssignment, 'grade_type') === 'points');
        const overallGrade = resolveOverallGradeForPrint({
            grade: gradeProp,
            isUngraded: isunGraded,
            isReturnedForSession: isReturnedForHeader,
            submission: submissionForAi,
            getMarkStatus,
            getMarkStatusBingo,
        });
        const proficiencyLevel = resolveAiGradingLevel({
            submission: submissionForAi,
            activityAssignment: selectedAssignment,
            combinedAssignments: selectedAssignment ? [selectedAssignment] : [],
            selectedStudentId: get(userInfo, 'id') || get(submissionForAi, 'userId'),
            currentClassId: get(currentClass, 'id'),
            currentSubmissionNo: submissionNumber,
        });
        await generateAssignmentPDF({
            pdfContentRef,
            showAlert,
            clearGeneratingState: () => setGeneratingPDFForId(null),
            setPdfData,
            questions: submissionQuestions,
            answers: submissionAnswers,
            studentName,
            assignmentDisplayName,
            className,
            submissionNumber,
            aiGrades: get(submissionForAi, 'ai_grade', []) || [],
            aiFeedbacks: get(submissionForAi, 'ai_feedback', []) || [],
            aiSuggestions: get(submissionForAi, 'ai_suggestion', []) || [],
            overallGrade,
            proficiencyLevel,
        });
    }, [
        showAlert,
        pdfContentRef,
        setPdfData,
        userInfo,
        getDisplayName,
        submissionsData,
        selectedAssignment,
        currentClass,
        grade,
        isAiPermissionEnabled,
        getMarkStatus,
        getMarkStatusBingo,
    ]);
    const handleSwitchChange = (event) => {
      isRubricToggleRef.current = true;
      setSelectedAssignment((prev) => {
        const data = {...prev};
        data.isShowRubric = event.target.checked;
        return data;
    })
        setAssignmentshow(!assignmentshow);
    };
    const hasRubricsData = (rubricsData) => {
        if (!rubricsData) return false;
        if (Array.isArray(rubricsData)) return rubricsData.length > 0;
        if (typeof rubricsData === 'object') return Object.keys(rubricsData).length > 0;
        return false;
    };
    const ShowAndHideRubric = useCallback(({ className = "", submissionRubricsData }) => {
      const hasSubmissionRubrics = hasRubricsData(submissionRubricsData);
      const hasAssignmentRubrics = assignmentRubrics && assignmentRubrics.id;
      const hasRubrics = hasSubmissionRubrics || hasAssignmentRubrics;
      if (!hasRubrics) return null;
      return (
        <div
          className={`${className} show-rubric-container`}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            fontWeight: "bold",
            marginBottom: is_mobile_menu ? 0 : "10px",
            paddingRight:8
          }}
        >
          <Switch
            name="viewSpecialSupport"
            color="primary"
            size="small"
            onChange={handleSwitchChange}
            defaultChecked={assignmentshow}
            checked={assignmentshow}
          />
          {!assignmentshow ? (
            <span className='text-ft11'>Show Rubric</span>
          ) : (
            <span className='text-ft11'>Show Response</span>
          )}
        </div>
      )
    }, [assignmentRubrics, assignmentshow])
    const pastSubmissionView = useCallback(() => {
        if (pastSubmissions && pastSubmissions.length > 0) {
            const isunGraded = get(selectedAssignment, "ungraded");
            const isPointSystem = get(selectedAssignment, "grade_type") === "points";
            return (<div>
                {map(pastSubmissions, (pt, i) => {
                   const grade = getGradeWithPreference(pt, isPointSystem);
                    const hmark = getHigestMark(pt, isAiPermissionEnabled)
                    const sessionLogId = getSubmissionActivityLogId(pt);
                    let mark = hmark.isHighest ? `Highest(${grade ? grade : hmark.val })` : `(${hmark.progress ? "in-progress" : grade ? grade : hmark.val})`;
                    mark = isunGraded ? "Credit" : mark;
                    const isreturned = get(pt, "submissions") == parseInt(get(submissionsData, "returned")) - 1;
                    const isReturnedForHeader = (Number(pt?.returned) > 0 ?  Number(pt?.submissions) === (Number(pt?.returned) - 1) : false)
                    return (<Accordion square expanded={expanded === pt.id} onChange={handleChangeExpend(pt.id)}>
                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                            <AccordianTitle>
                                <span>{"Submission-" + (i + 1)} {mark} {isReturnedForHeader ? `(Returned)` : null} {isGradedByTeacher(pt,true)}</span>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    {get(pt, "answers.length", 0) > 0 && (
                                        <HeaderDownloadButton
                                            type="button"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                const ptQuestions = get(submissionsData, "assignment.questions", []);
                                                const ptAnswers = get(pt, "answers", []);
                                                handleDownloadPDF(ptQuestions, ptAnswers, pt.id, i + 1, pt);
                                            }}
                                            disabled={!!generatingPDFForId}
                                        >
                                            {generatingPDFForId === pt.id ? (
                                                <Loading size={14} white />
                                            ) : (
                                                <>
                                                    <Download fontSize="small" style={{ fontSize: '14px' }} />
                                                </>
                                            )}
                                        </HeaderDownloadButton>
                                    )}
                                    <Rotate open={expanded === pt.id}><ArrowRight /></Rotate>
                                </div>
                            </AccordianTitle>
                        </AccordionSummary>
                        {hmark.progress ? (
                       <Notification>
                       {get(userInfo, "firstName", "")}{" "}
                       {get(userInfo, "lastName", "")} is in the process of{" "}
                       {/* {get(selectedAssignment, "pastSubmissions.length") == 0
                         ? "taking"
                         : "retaking"}{" "} */}

                       taking this assignment and due to that you might see partial/no
                       answers below. If there is a grade for this assignment it
                       has been stored from a previous submission.
                     </Notification>

                    ) : null}

                        <AccordionDetails>
                            <GradeDisplay
                                key={pt?.id}
                                answers={get(pt, "answers")}
                                feedback={get(pt, "feedback")}
                                audioFeedback={get(pt, "audioFeedback")}
                                ai_suggestion={get(pt, "ai_suggestion")}
                                ai_feedback={get(pt, "ai_feedback")}
                                grade={grade}
                                name={getDisplayName(submissionsData)}
                                questions={get(submissionsData, "assignment.questions", [])}
                                type={get(submissionsData, "assignmentType") == "quiz" ? "quiz" : null}
                                isExpended
                                isLate={false}
                                hasFeedback={true &&(get(pt, "feedback")|| get(pt, "audioFeedback"))}
                                isUngraded={isunGraded}
                                assignment={pt}
                                activity={selectedAssignment}
                                rubricsToggle={ShowAndHideRubric({submissionRubricsData:get(pt, "rubrics_data")})}
                                in_progress={hmark.progress}
                                showStudentTrackingButton={Boolean(currentUser?.role && currentUser.role !== 'student' && sessionLogId)}
                                onStudentTrackingClick={() => {
                                    setTrackingLogId(sessionLogId);
                                    setTrackingSubmissionLabel(`Submission-${get(pt, "submissions", i + 1)}`);
                                }}
                            />
                        </AccordionDetails>
                    </Accordion>
                    )
                })}
            </div>)

        }
        else {
            return null;
        }

    }, [pastSubmissions, expanded , ShowAndHideRubric, isAiPermissionEnabled, getGradeWithPreference, handleDownloadPDF, generatingPDFForId, submissionsData, selectedAssignment, userInfo])

    const categories = ["All", "Missing", "Incomplete", "Excused", "Returned"];
    const categoryNav = () => {
        return {
          items: map(categories, (ct) => ({
            key: ct,
            label: (
              <PaddedBtn
                onClick={() => {
                  filterStudentList(ct);
                }}
              >
                {ct}
              </PaddedBtn>
            ),
            style: { padding: "0px" }
          }))
        };
    };

    const CurrentSubmissionView = useMemo(() => {
        const graphicOrgInProgress = isGraphicOrgInProgress(submissionsData, selectedAssignment);
        if (submissionsData?.submissions != 0 || (submissionsData?.submissions == 0 && (submissionsData?.answers?.length > 0 || (submissionsData.graded && !submissionsData.isTemp) || graphicOrgInProgress))) {
            let PastSub = 0;
            map(pastSubmissions, pt => (
                PastSub = parseInt(pt.submissions)
            ));
            const LastSub = PastSub ? PastSub : 0;
            const CurrentSub = LastSub + 1;
            let Title = "";
            if (CurrentSub === 1) {
                Title = pastSubmissions?.length + 1;
            } else {
                Title = (pastSubmissions?.length + 1) + ' (Last Submission)';
            }
            const isunGraded = get(selectedAssignment, "ungraded");
            const hmark = getHigestMark(submissionsData, isAiPermissionEnabled);
            let mark = hmark.isHighest ? `Highest(${hmark.val})` : `(${hmark.progress ? "in-progress" : hmark.val})`;
            mark = getSubmissionStatus(submissionsData).inProgressStatus || graphicOrgInProgress ? ("(In Progress)") :submissionsData?.assignmentType === "bingo" ? getMarkStatusBingo(isunGraded,submissionsData?.submissions || 0,submissionsData) : getMarkStatus(isunGraded,submissionsData?.submissions || 0,submissionsData);
            let worksheet_question = []
            const is_game = submissionsData?.assignmentType === "game";
            const is_debate = submissionsData?.assignmentType === "debate";
            const is_worksheet = submissionsData?.assignmentType === "worksheet";
            const is_loteria = get(submissionsData, "assignmentType", '') === "bingo"
            if(is_worksheet){
              worksheet_question = questions[selectedAssignment.game_id]? questions[selectedAssignment.game_id]:[]
            }
            const isReturnedForHeader = (submissionsData?.returned > 0 && submissionsData?.submissions == (submissionsData?.returned - 1))
            const currentSessionLogId = getSubmissionActivityLogId(submissionsData);
            return (<div>
                {<Accordion square expanded={expanded === get(submissionsData, "id")} onChange={handleChangeExpend(get(submissionsData, "id"))}>
                    <AccordionSummary style={CurrentSubmission} aria-controls="panel1d-content" id="panel1d-header">
                        <AccordianTitle>
                            <span>{"Submission-" + Title}  {mark} {isReturnedForHeader ? `(Returned)` : null} {isGradedByTeacher(submissionsData)}</span>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {get(submissionsData, "answers.length", 0) > 0 && (
                                    <HeaderDownloadButton
                                        type="button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            const is_worksheet = get(submissionsData, "assignmentType") === "worksheet";
                                            const submissionQuestions = is_worksheet
                                                ? worksheet_question
                                                : get(submissionsData, "assignment.questions", []);
                                            const submissionAnswers = get(submissionsData, "answers", []) || [];
                                            handleDownloadPDF(
                                                submissionQuestions,
                                                submissionAnswers,
                                                get(submissionsData, "id"),
                                                pastSubmissions.length + 1,
                                                submissionsData
                                            );
                                        }}
                                        disabled={!!generatingPDFForId}
                                    >
                                        {generatingPDFForId === get(submissionsData, "id") ? (
                                            <Loading size={14} white />
                                        ) : (
                                            <>
                                                <Download fontSize="small" style={{ fontSize: '14px' }} />
                                            </>
                                        )}
                                    </HeaderDownloadButton>
                                )}
                                <Rotate open={expanded === get(submissionsData, "id")}><ArrowRight /></Rotate>
                            </div>
                        </AccordianTitle>
                    </AccordionSummary>
                    {hmark.progress ? (
                       <Notification>
                       {get(userInfo, "firstName", "")}{" "}
                       {get(userInfo, "lastName", "")} is in the process of{" "}
                       {/* {get(selectedAssignment, "pastSubmissions.length") == 0
                         ? "taking"
                         : "retaking"}{" "} */}

                       taking this assignment and due to that you might see partial/no
                       answers below. If there is a grade for this assignment it
                       has been stored from a previous submission.
                     </Notification>

                    ) : null}
                    <AccordionDetails>
                        <GradeDisplay
                            key={get(submissionsData, "id")}
                            answers={get(submissionsData, "answers")}
                            feedback={get(submissionsData, "feedback")}
                            ai_feedback={get(submissionsData, "ai_feedback")}
                            ai_suggestion={get(submissionsData, "ai_suggestion")}
                            audioFeedback={get(submissionsData, "audioFeedback")}
                            grade={ grade || getAssignmentGradeValue(submissionsData,selectedAssignment, isAiPermissionEnabled)}
                            name={getDisplayName(submissionsData)}
                            questions={is_worksheet?worksheet_question:get(submissionsData, "assignment.questions", [])}
                            type={get(submissionsData, "assignmentType") == "quiz" ? "quiz" : null}
                            isExpended
                            isLate={false}
                            hasFeedback={false}
                            is_game={is_game}
                            selected_student_id={submissionsData?.userId}
                            is_debate={is_debate}
                            is_loteria={is_loteria}
                            isUngraded={isunGraded}
                            assignment={submissionsData}
                            rubricsToggle={ShowAndHideRubric({submissionRubricsData:get(submissionsData, "rubrics_data")})}
                            activity={selectedAssignment}
                            is_worksheet={is_worksheet}
                            show_ai_grade_button={checkIsManualGradable(get(submissionsData, "assignment.questions", []))}
                            showReturnButton
                            isReturnedFromSession={isReturnedForHeader}
                            onReturnSuccess={onReturnSuccess}
                            currentSubmissionNo={CurrentSub}
                            in_progress={hmark.progress}
                            showStudentTrackingButton={Boolean(currentUser?.role && currentUser.role !== 'student' && currentSessionLogId)}
                            onStudentTrackingClick={() => {
                                setTrackingLogId(currentSessionLogId);
                                setTrackingSubmissionLabel(`Submission-${Title}`);
                            }}
                        />
                    </AccordionDetails>
                </Accordion>}
            </div>)
        }
        return null;
    }, [submissionsData, expanded, ShowAndHideRubric, questions, selectedAssignment, isAiPermissionEnabled, returnedSubmissionIds, onReturnSuccess, grade, handleDownloadPDF, generatingPDFForId, pastSubmissions, userInfo]);

    const getMark = (subm, isTbg, isUngraded, isCompleteInComplete, isActive, isAiPermissionEnabled, assignmentMeta) => {
        const is_return = isReturned(subm)
        if (is_return) {
            return "Returned"
        }
        else if (subm.complete && isTbg && !isUngraded && !isCompleteInComplete && isActive) {
          let bg_text;
          const is_graphic_organizer = isGraphicOrganizer(subm, assignmentMeta);
           if (currentUser?.role === 'student') {
             bg_text = 'TBG';
           } else {
            //  bg_text = subm&&subm.ai_grade&&subm.ai_grade?.length > 0?"TBG - AI": isAiPermissionEnabled ? "TBG - AI" : "TBG";
             bg_text = is_graphic_organizer ? "TBG" : (isAiPermissionEnabled ? "TBG - AI" : "TBG");
           }
            return bg_text;
        } else return null
    }
  const pageCover = usePageCover({ assignmentData: selectedAssignment?.data });
  const page_src = useMemo(() => {
    if (!selectedAssignment) return null;
    if(pageCover){
      return pageCover;
    }
    const cover_img_ext = getCoverForAssignment(selectedAssignment)
    if (cover_img_ext) {
      return cover_img_ext;
    }
    return isVideo(get(selectedAssignment, "data.chapter"), resources) ? imageFetchFromPodcast(get(selectedAssignment, "data.chapter"), resources) : imageFetch(booksAllList, get(selectedAssignment, "data.chapter"), get(selectedAssignment, "data.page"))
  }, [selectedAssignment, data, resources,pageCover])

    const is_soy_story = useMemo(() => {return selectedAssignment && ((typeof selectedAssignment?.data?.storyInstruction == "string" && selectedAssignment?.data?.storyInstruction?.length > 0));}, [selectedAssignment])
    const coverTitle = useAssignmentCoverTitle({ assignment: selectedAssignment });
    const PosterIg = useMemo(() => {
        if (!selectedAssignment) return null;
        return (<ImageContiner className='relative'>
          <Image src={page_src} alt='ebook image' className='cursor-pointer' />
          {coverTitle ? <ImageStoryTitle className='customImgTitleReview' fontSize="3px">{coverTitle}</ImageStoryTitle> : null}
        </ImageContiner>)
    }, [coverTitle, page_src, selectedAssignment])

    const handleRubricUpdate = (gradeMarking, totalGrade) => {
        const grade_type = get(selectedAssignment, "grade_type")
        const max_point = get(selectedAssignment, "max_point") >= 0 ? get(selectedAssignment, "max_point", 100) : 100
        const isPointSystem = grade_type === "points"
        const rubric_max_point = assignmentRubrics && assignmentRubrics.rubrics_meta ? assignmentRubrics.rubrics_meta.reduce((sum, criterion) => sum + Math.max(...criterion.points.map(point => point.pointText)), 0) : max_point;
        const percent = Math.round((totalGrade / rubric_max_point) * 100);
        let face_value = 0;
        if (max_point) {
            const assignment_max_point = max_point;
            if (rubric_max_point != assignment_max_point) {
                face_value = Math.round((percent / 100) * assignment_max_point);
            } else {
                face_value = totalGrade;
            }
        } else {
            face_value = totalGrade;
        }
        setGrade( isPointSystem ? face_value : percent)
        try {
            setSelectedAssignment({...selectedAssignment , submissions:{...selectedAssignment.submissions ,  face_value:face_value , grade:percent }}) 
        } catch (error) {
            Sentry.captureException(`605 Error in handleRubricUpdate: ${error}`);
        }
        handleSubmit(null, null, false, isPointSystem ? face_value : percent, null, selectedAssignment, gradeMarking)
    }

    const handlePaneResize = (newSizes) => {
      if (isLargeScreen) {
        const screenWidth = window.innerWidth;
        
        const minSizePane1 = 600;
        const minSizePane2 = 500;
        const maxSizePane1 = screenWidth * 0.6;  // 60% of screen width
        const maxSizePane2 = screenWidth * 0.8;  // 80% of screen width
    
        const adjustedSizes = [
          Math.min(Math.max(newSizes[0], minSizePane1), maxSizePane1),
          Math.min(Math.max(newSizes[1], minSizePane2), maxSizePane2),
        ];
        
        setSizes(adjustedSizes);
      } else {
        setSizes(newSizes);
      }
    };

      const ImagePoster = () => {
        return (
          <div>
          <div
            onClick={() => {
              setModalOpen(true);
          
            }}
            style={{ width: is_mobile_menu ? "33px" : "69px", height: is_mobile_menu ? "43px" : "84px", cursor: "pointer" }}
          >
            {PosterIg}
          </div>
          {is_mobile_menu ? null : (
            <AssignmentImg
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              setModalOpen(true);
            }}
            >
            <EyeOutlined />
            </AssignmentImg>
          )}
         
        </div>
        )
      }

      function panel1(){
        return (
            <div style={{ padding: is_mobile_menu ? "8px" :"", paddingTop: "0px", paddingLeft: "10px", paddingRight: "10px" }}>
                <div
                  xs={24}
                  sm={24}
                  md={24}
                  xl={15}
                  lg={tabletType ? 24 : 10}
                  style={{
                    marginBottom: 14,
                    flex: "1 1 auto",
                  }}
                >
                  <div style={{ display: "flex" }} className="viewAssignmentRgt"> 
                    {!is_mobile_menu && <ImagePoster />}
                
                    <div style={{ width: "100%" }}>
                  
                  <UserAddignmentLabel style={{ marginBottom: 8 }}>
                        <div className='flex items-center'>
                        <HeaderWrapper>
                            <div className='flex items-center'>
                              {is_mobile_menu && <ImagePoster />}
                              <strong className='ml-4px' style={{ marginRight: "6px" }}>Student:</strong>{" "}
                              <span style={{ marginRight: "3px" }}>
                                  {SelectedUserDropDown()}
                              </span>{" "}
                            </div>
                          <div>
                          <strong style={{ marginLeft: "3px", marginRight: "6px" }}>
                            |{" "}
                            Status:{" "}
                          </strong>{" "}
                          {getStatus(get(selectedAssignment, "submissions", ""))}
                          </div>
                          <div>
                          <strong style={{ marginLeft: "3px", marginRight: "6px" }}>
                          | Due on:{" "}
                          </strong>{" "}
                          {getAssignmentDueOn()}
                        </div>
                        </HeaderWrapper>

                      
                        </div>
                      </UserAddignmentLabel>
                      {inProgressSatatus && (
                        <>
                       
                        {/* <SubmissionMessage className='submission-image-container' style={{flexDirection: "column"}}>
                             Submission in progress
                               <div className='mt-10px '>
                                    <img className='image-for-open-submission' src={assignmentImage} alt='submissionImage'/>
                                </div>
                            </SubmissionMessage> */}
                        </>
                      )}
                      {submissionStatus && (
                        <>
                        {/* <Notification bgColor={COLOR.yellow} color={COLOR.white}>
                          The student has not submitted this assignment
                        </Notification> */}
                        <SubmissionMessages className='submission-image-container' style={{flexDirection: "column"}}>
                                No submission available
                                <div className='mt-10px '>
                                    <img className='image-for-open-submission' src={assignmentImage} alt='submissionImage'/>
                                </div>
                            </SubmissionMessages>
                        </>
                      )}
                      {/* {timmerStatus && (
                        <Notification>
                          This is a time-test assessment, if there are any blank
                          answers, it means the student did not complete within time
                          given.
                        </Notification>
                      )} */}
      
                      <PreviewArea style={{minHeight:expanded === get(submissionsData, "id") ? "150px" : "0px"}}>
                        {pastSubmissionView()}
                        {CurrentSubmissionView}
                      {!expanded &&
                        !submissionStatus &&
                        !timmerStatus  && (
                          <SubmissionMessage style={{flexDirection: "column"}} className='submission-image-container submission-image-container-open-submission'>
                            Open a submission to see responses
                            <div className='mt-10px '>
                              <img className='image-for-open-submission' src={openSubMissionImage} alt='submissionImage'/>
                          </div>
                          </SubmissionMessage>
                        )}
                      </PreviewArea>
                    </div>
                  </div>
                </div>
              </div>
        )
      }

      const Panel2 = () => {
        return (
            <div style={{ paddingInline: "10px", paddingTop:"0px" }}>
            <div
              xs={24}
              sm={24}
              md={7}
              style={{
                marginBottom: 14,
                //   width: "300px",
                // width:"575px",
                marginLeft: "10px",
                flexShrink: 0,
              }}
            >
              {!assignmentshow ? (
                <div>
                  <div className="viewAssignmentLft">
                    {UserSubsmissionList()}
                    <AssignmentDeviceModal
                      className="max-w-581px"
                      modalOpen={modalOpens}
                      setModalOpen={setModalOpens}
                      onClose={handleCloseModal}
                    />
                  </div>
                  {AudioRecorderAndGrade()}
                </div>
              ) : (
                <GradebookRubric
                  assignmentRubrics={assignmentRubrics}
                  currentSubmissionRubric={currentSubmissionRubric}
                  loading={loading == "u"}
                  handleRubricUpdate={handleRubricUpdate}
                />
              )}
            </div>
          </div>
        )
      }


      const UserSubsmissionList = useCallback(() => {
        return (
          <div className='studentUsrSlectClass'>
            <UserSelector style={{ height: "auto", marginTop: is_mobile_menu ? 10 : 0 }}>
              <strong style={{ minWidth: 60 }}>Filter Student</strong>
              <Dropdown
                menu={categoryNav()}
                placement="bottomRight"
                trigger={["click"]}
                // getPopupContainer={(trigger) => trigger.parentNode}
              >
                <CategoryMenu>
                  {select} <MenuIconImg src={MenuIcon} />{" "}
                </CategoryMenu>
              </Dropdown>
            </UserSelector>
                    <UserSelectorList checkFrame={checkFrame}>
            {userSubmissions.length > 0 ? (
              map(userSubmissions, (usrAssignments, i) => {
                const isUngraded = get(usrAssignments, "ungraded");
                const grade_type = get(usrAssignments, "grade_type");
                let max_point = get(usrAssignments, "max_point", 100);
                if (max_point == null) {
                  max_point = 100;
                }
                const isCompleteInComplete = grade_type === "complete_incomplete";
                const isPointSystem = grade_type === "points";
                const isActive =get(selectedAssignment, "id") ==get(usrAssignments, "id");
                const disabled = updateLoading ||get(usrAssignments, "submissions.exceptionStatus") > 0 || isUngraded || !is_user_not_active;
                const submissions = get( usrAssignments, "submissions", {} );
                const assignment_grade = getAssignmentGradeValue(submissions,usrAssignments, isAiPermissionEnabled);
                const isTbg = checkIsTbgTxt(assignment_grade);
                const value_result = isActive ? ((typeof grade === "number" && grade >= 0) || typeof grade === "string" ? grade : "-") : assignment_grade;
                const is_active = get(selectedAssignment, "data.id") ==
                get(usrAssignments, "data.id")
                const isDoneLate = isDoneLateSubmission(get(usrAssignments, "submissions", ""));
                const validAiFeedback = hasValidAiFeedback(selectedAssignment?.submissions);
                return (
                  <UserSelector
                    className='user-select-list-review userSelectListReviewUpr'
                    key={get(usrAssignments, "user.id")}
                    active={is_active}
                    onClick={(event) => {
                      if(!is_mobile_menu){
                        event.stopPropagation();
                        setData(usrAssignments);
                        setSelectedAssignment(prev => {
                            const data = {...prev}
                            data.isPreview = true;
                            return data;
                        })
                      }
                 }}
                  >
                  
                  <div className='userSelectListReviewLeft'>
                     <div  onClick={(event) => {
                      if(is_mobile_menu){
                        event.stopPropagation();
                        setData(usrAssignments);
                        setSelectedAssignment(prev => {
                            const data = {...prev}
                            data.isPreview = true;
                            return data;
                        })
                      }
                 }} className='flex items-center'>
                        <EyeOutlined className='eye-icon-assignment-review' style={{marginRight: "10px"}}  />
                    {get(usrAssignments, "displayName", "")?.length > 25 ? (
                      <Tooltip showArrow={false} overlayClassName='student-review-tooltip' title={get(usrAssignments, "displayName", "")} placement='top' >
                          <NameText className='text-wrap d-inline-flex'>
                          {get(usrAssignments, "displayName", "")}</NameText>
                      </Tooltip>
                    ) : (
                    <NameText style={{ width:"120px"}} className='text-wrap d-inline-flex'>
                        {get(usrAssignments, "displayName", "")}
                    </NameText>
                    )}
                    </div>
                  </div>  


                  <div className='userSelectListReviewMid'>
                    <div  onClick={(event) => {
                      if(is_mobile_menu){
                        event.stopPropagation();
                        setData(usrAssignments);
                      }
                 }} className='flex items-center justify-center w-full'>
                    {updateLoading &&
                    updateLoading == get(usrAssignments, "id") ? (
                      <Loading size={14} white={isActive} />
                    ) : null}
                    {!validAiFeedback? null : isUngraded
                      ? usrAssignments?.submissions?.assignmentType === "bingo" ? getMarkStatusBingo(isUngraded,usrAssignments?.submissions?.submissions || 0, usrAssignments?.submissions) : getMarkStatus(isUngraded,usrAssignments?.submissions?.submissions || 0,usrAssignments?.submissions)
                      : ""}
                    {!validAiFeedback? null : isCompleteInComplete
                      ? getCompleteInclompleteMark(has(submissions, "id") &&submissions.grade > 0,has(submissions, "id") &&submissions.grade == 0,isActive, usrAssignments)
                      : null}
                    {!validAiFeedback? null : getMark(submissions, isTbg, isUngraded, isCompleteInComplete, isActive, isAiPermissionEnabled, usrAssignments)}
                    {!isUngraded && !isCompleteInComplete ? (
                      <>
                        {isActive ? (
                          <>
                          <GradeEditorInput
                            style={{margin:"0px 5px"}}
                            disabled={!validAiFeedback || disabled || !assignedStudentList}
                            inputRef={(re) =>(inputsRefs.current[i] = re) }
                            onChange={handleChange}
                            onFocus={(e) => {
                              if (e.target.value === "-") {
                                e.target.value = "";
                              }
                              handleFocus(e);
                            }}
                            value={!validAiFeedback? "-" : !assignedStudentList ? "N/A" : value_result}
                              onBlur={(e) => {
                                if (e && e.target && e.target.value === '') {
                                  return;
                                }
                                const v = e && e.target ? e.target.value : value_result
                                if (typeof v == "string" && (updateLoading || checkIsTbgTxt(v) || v.includes("-") || v === '' || v === null)) return;
                                if (submissions && (isPointSystem ? v == submissions.face_grade : v == submissions.grade)) return;
                                handleSubmit(e, null, false, v, null, usrAssignments);
                              }}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === 13) {
                                  onEnterPress()
                                  e.preventDefault();
                                  const v = e&&e.target?e.target.value:value_result
                                  if((typeof v ==="string" && checkIsTbgTxt(v) || v.includes("-") || v === '' || v.trim() =='')||v==null ||!(v==0||v>0)) return;
                                  handleSubmit(e,null, false,v,null,usrAssignments);  
                              }
                              else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                                  if (e && e.target && (updateLoading || checkIsTbgTxt(e.target.value) || e.target.value.includes("-") || e.target.value === '' || e.target.value === null)) return;
                                  const v = e&&e.target?e.target.value:value_result
                                  if(usrAssignments &&(isPointSystem?v==usrAssignments.face_grade : v==usrAssignments.grade)) return;
                                  handleSubmit(e,null, false,v,null,usrAssignments);          
                              }
                          }}
                          />
                          {isDoneLate ? <span style={{marginRight: "2px"}}>Done late</span> : ""}
                          </>
                        ) : (
                          <span style={{ margin: 2 }}>
                            {!validAiFeedback? "-" : assignment_grade}
                            {isPointSystem ? (
                              <MaxPointText
                                style={{
                                  color: isActive
                                    ? "#fff"
                                    : COLOR.gray100,
                                  marginRight: 5,
                                }}
                              >{`/${max_point}`}</MaxPointText>
                            ) : null}
                          </span>
                        )}
                      </>
                    ) : null}
                     {isActive && isPointSystem?<MaxPointText style={{color:isActive?"#fff":COLOR.gray100,marginRight:5}}>{`/${max_point}`}</MaxPointText>:null}
                    </div> 
                  </div>
                         
                  <div className='userSelectListReviewRght'>
                    <NameText
                     onClick={(event) => {
                      if(is_mobile_menu){
                        event.stopPropagation();
                        setData(usrAssignments);
                      }
                    }}>
                      {usrAssignments?.submissions?.createdAt && usrAssignments?.submissions?.complete ? (
                            <Tooltip overlayClassName='student-review-tooltip' showArrow={false} destroyTooltipOnHide={true} placement='top' title= {getStatus(
                                get(usrAssignments, "submissions", ""),
                                usrAssignments
                              )}>
                              {getStatus(
                                get(usrAssignments, "submissions", ""),
                                usrAssignments
                              )}
                            </Tooltip>
                      ) : (
                        <>
                         {getStatus(
                            get(usrAssignments, "submissions", ""),
                            usrAssignments
                          )}
                        </>
                      )}
                    </NameText>
                  </div>

                  </UserSelector>
                );
              })
            ) : (
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                No Data Found
              </div>
            )}
          </UserSelectorList>
            </div>
          
        )
      },[userSubmissions,grade,selectedAssignment,updateLoading, assignedStudentList, isAiPermissionEnabled]);


      const isValidFeedback = useMemo(() => {
        return hasValidAiFeedback(selectedAssignment?.submissions);
      }, [selectedAssignment]);


      const MobileNavSubmission = () => {
        return (
          // <div className='flex items-center justify-between button-for-mob-container arrow-icon-container'>
          //   <button className='button-for-mob-nav left-button-review' onClick={() => backwardForward("backward")}>
          //       <ChevronLeftOutlined className='arrow-icon' style={{color: "black"}} />
          //     </button>
              
          //     <button className='button-for-mob-nav right-button-review'  onClick={() => backwardForward("forward")}>
          //           <ChevronRightOutlined className='arrow-icon' style={{color:  "black"}} />
          //     </button>
          // </div>
          <div className="arrow-icon-container" style={{position:"relative"}}>
        <button
          className="button-for-mob-nav left-button-review"
          onClick={() => backwardForward("backward")}
        >
          <ChevronLeftOutlined className='arrow-icon' style={{ color: "black" }} />
        </button>

        <button
          className="button-for-mob-nav right-button-review"
          onClick={() => backwardForward("forward")}
        >
          <ChevronRightOutlined className='arrow-icon' style={{ color: "black" }} />
        </button>
      </div>
        )
      }

      const AudioRecorderAndGrade = () => {
        return (
         <div  style={{bottom: checkFrame && "0px" }} className={`audio-recorder-grade-div`} >   
          {/* */}
              {is_mobile_menu && <MobileNavSubmission />}
              
              <Row style={{ paddingInline: is_mobile_menu ?  "20px" : "", marginBottom: is_mobile_menu ? "10px" :"24px", marginTop: 12 }}>
                    <div className='flex items-center justify-between w-full'>
                    <Description
                      style={{
                        marginBottom: 0,
                        opacity:
                          !submissionsData || !submissionsData.id ? 0.5 : 1,
                      }}
                    >
                      Student Feedback
                    </Description>
                    {/* {is_mobile_menu &&  <>
                      {ShowAndHideRubric()}
                    </>} */}
                    </div>
                    
                    <TextField
                      id="feedback"
                      onChange={handleFeedback}
                      variant="outlined"
                      onFocus={() => {
                        is_feedback_input_active.current = true;
                      }}
                      value={feedback}
                      disabled={!submissionsData || !submissionsData.id || !assignedStudentList}
                      multiline
                      rows={10}
                      placeholder="Type feedback here."
                      onBlur={(e) => {
                        is_feedback_input_active.current = false;
                        if (e.target.value && e.target.value.trim().length > 0) {
                          if (submissionsData && submissionsData.id && (submissionsData.graded || Number(submissionsData?.grade) > 0)) {
                            handleSubmit(
                              null,
                              null,
                              false,
                              null,
                              e.target.value,
                              selectedAssignment
                            );
                          } else {
                            setAlertSakeBar({
                              open: true,
                              message: "Please grade the assignment before submitting feedback.",
                              severity: "error",
                            });
                          }
                        }
                      }}
                      className={`${is_mobile_menu && "tab-mob-student-feedback-field"} feedbackform viewStudntFeedback`}
                    />
                  </Row>
                  {submissionsData && submissionsData.id ? (
                    <>
           
                    <Row style={{paddingInline: is_mobile_menu ? "24px" : "0px" }}>
                        <Description style={{ marginBottom: 0 }}>
                        You can record student feedback here.
                        </Description>
                  
                    
                      {!is_mobile_menu ? 
                      <div className='flex gap-10px w-full justify-between audio-recorder-nav'>
                     <AudioRecorder
                     maxTime={120}
                     wrapperStyle={{
                       border: "0px solid #e8e8e8",
                       padding: "0px 0px 0px",
                     }}
                     ref={feedbackAudioRef}
                     message={"Record your Feedback"}
                     handleAudio={(url) => {
                       setAudioFeedback(url);
                       handleSubmit(
                         null,
                         url,
                         false,
                         null,
                         null,
                         selectedAssignment
                       );
                     }}
                     refresh={() => navigate(0)}
                     source={audioFeedback}
                     hasSaveButton={submissionsData && submissionsData.id}
                     type={"student-submission-review"}
                     isMobileDevice={is_mobile_menu}
                     disabled={!assignedStudentList}
                   /> 
                   </div>
                  //  for mobile
                   :   
                   <div className='flex items-center newItemCenter' style={{position: "relative", width: "100%"}}>
                    <AudioRecorder
                     maxTime={120}
                     wrapperStyle={{
                       border: "0px solid #e8e8e8",
                       padding: "0px 0px 0px",
                     }}
                     ref={feedbackAudioRef}
                     message={"Record your Feedback"}
                     handleAudio={(url) => {
                       setAudioFeedback(url);
                       handleSubmit(
                         null,
                         url,
                         false,
                         null,
                         null,
                         selectedAssignment
                       );
                     }}
                     refresh={() => navigate(0)}
                     source={audioFeedback}
                     hasSaveButton={submissionsData && submissionsData.id}
                     type={"student-submission-review"}
                     isMobileDevice={is_mobile_menu}
                     disabled={!assignedStudentList}
                   />
                     
                     <Row justify="end" className='newItemCenters' style={{position: "absolute", right: "-11px", top: "19px"}}>
                   {!get(selectedAssignment, "ungraded") &&
                   get(selectedAssignment, "grade_type") !=
                     "complete_incomplete" ? (
                     <div style={{ position: "relative" }}>
                       <TextField
                         id="grade"
                         label="Grade"
                         onChange={handleChange}
                         onKeyDown={handleGradeFieldKeyDown}
                         variant="outlined"
                         value={!isValidFeedback? "-" : !assignedStudentList ? "N/A" :grade}
                         ref={inputRef}
                         onFocus={handleFocus}
                         style={{
                           marginRight: "8px",
                           width: "45px",
                           textAlign: "center",
                           height: is_mobile_menu ? "10px" : "40px"
                         }}
                         InputProps={{
                          style: {
                            height: is_mobile_menu ? "30px" : "40px"
                          }
                        }}
                         className={"gradeUpdate student-review-field"}
                         disabled={
                           !isValidFeedback ||
                           get(submissionsData, "exceptionStatus") > 0 ||
                           get(selectedAssignment, "ungraded") ||
                           !is_user_not_active ||
                           !assignedStudentList
                         }
                       />
                       <div className='tbg-grade-font' style={{ paddingLeft: 10,marginTop: "10px"  }}>
                         {!isValidFeedback? null : current_assignment_returned
                           ? "returned"
                           : selected_assignment_tbg
                           ? is_graphic_organizer_assignment ? "TBG" : (isAiPermissionEnabled ? "TBG - AI" : "TBG")
                           : ""}
                       </div>
                     </div>
                   ) : null}
                   {get(selectedAssignment, "grade_type") === "points" ? (
                     <MaxPointText
                        className='tbg-grade-font'
                       style={{
                         marginRight: 2,
                         alignSelf: "center",
                         fontSize: "large",
                       }}
                     >{`/${get(
                       selectedAssignment,
                       "max_point",
                       100
                     )}`}</MaxPointText>
                   ) : null}
                   <Button
                   style={{height: is_mobile_menu ? "31px" : ""}}
                     variant="contained"
                     color="primary"
                     type="submit"
                     disabled={
                       !isValidFeedback ||
                       loading ||
                       updateLoading ||
                       grade === "-" ||
                       grade === "" ||
                       grade === null || 
                       !assignedStudentList
                     }
                     onClick={(e) => {
                       handleSubmit(
                         e,
                         null,
                         false,
                         null,
                         null,
                         selectedAssignment
                       );
                       // closeModal()
                     }}
                   >
                     {loading == "u" ? <Loading size={20} white /> : "Update"}
                   </Button>
                 </Row>
                   </div>
                 
                    }
                    </Row>
                    </>
                  ) : null}

                  {/* // input for grade for laptop */}
                  {!is_mobile_menu && (
                      <Row justify="end">
                      {!get(selectedAssignment, "ungraded") &&
                      get(selectedAssignment, "grade_type") !=
                        "complete_incomplete" ? (
                        <div style={{ position: "relative" }}>
                          <TextField
                            id="grade"
                            label="Grade"
                            onChange={handleChange}
                            onKeyDown={handleGradeFieldKeyDown}
                            variant="outlined"
                            value={!isValidFeedback? "-" : !assignedStudentList ? "N/A" :grade}
                            ref={inputRef}
                            onFocus={handleFocus}
                            style={{
                              marginRight: "16px",
                              width: "56px",
                              textAlign: "center",
                            }}
                            className={"gradeUpdate"}
                            disabled={
                              !isValidFeedback ||
                              get(submissionsData, "exceptionStatus") > 0 ||
                              get(selectedAssignment, "ungraded") ||
                              !is_user_not_active || 
                              !assignedStudentList
                            }
                          />
                          <div style={{ paddingLeft: 15, position: "absolute" }}>
                            {!isValidFeedback? null : current_assignment_returned
                              ? "returned"
                              : selected_assignment_tbg
                              ? is_graphic_organizer_assignment ? "TBG" : (isAiPermissionEnabled ? "TBG - AI" : "TBG")
                              : ""}
                          </div>
                        </div>
                      ) : null}
                      {get(selectedAssignment, "grade_type") === "points" ? (
                        <MaxPointText
                          style={{
                            marginRight: 16,
                            alignSelf: "center",
                            fontSize: "large",
                          }}
                        >
                         {`/${selectedAssignment?.max_point || 100}`}
                        </MaxPointText>
                      ) : null}
                      <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={
                          !isValidFeedback ||
                          loading ||
                          updateLoading ||
                          grade === "-" ||
                          grade === "" ||
                          grade === null || 
                          !assignedStudentList
                        }
                        onClick={(e) => {
                          handleSubmit(
                            e,
                            null,
                            false,
                            null,
                            null,
                            selectedAssignment
                          );
                          // closeModal()
                        }}
                      >
                        {loading == "u" ? <Loading size={20} white /> : "Update"}
                      </Button>
                      </Row>
                  )}
                 
    </div>
)
      }
      

      const backwardForward = (action) => {
        const activeIndex = findIndex(userSubmissions, e => get(selectedAssignment, "id") == get(e, "id"));
        if(action === "backward"){
            if(selectedAssignment?.isShowRubric || assignmentshow) return;
            if (activeIndex > 0 && userSubmissions[activeIndex - 1]) {
                const data = userSubmissions[activeIndex - 1];
                data.isPreview = selectedAssignment?.isPreview ? true : false;
                if(!assignmentRubrics){
                  data.isShowRubric = false;
                }
                setData(data);
                onBlurInput()
            }
        }else{
            if(selectedAssignment?.isShowRubric || assignmentshow) return;
            if (activeIndex < userSubmissions.length && userSubmissions[activeIndex + 1]) {
                const data = userSubmissions[activeIndex + 1];
                data.isPreview = selectedAssignment?.isPreview ? true : false;
                if(!assignmentRubrics){
                  data.isShowRubric = false;
                }
                setData(data);
                onBlurInput()
            }
        }
      }

      const handleRefresh = async () => {
        if (!currentClass?.id) {
          showAlert("No class selected", "error");
          return;
        }
        try {
          setRefreshLoading(true);
          const refreshedSubmissions = await dispatch(handleListClassSubmissions(currentClass.id));
          if (Array.isArray(refreshedSubmissions) && refreshedSubmissions.length > 0) {
            studentSubmissionsRef.current = groupBy(refreshedSubmissions, "userId") || {};
          }
          if (userReviewAssignment && typeof userReviewAssignment === "function" && data?.user && data?.assignment) {
            await userReviewAssignment(data.user, data.assignment);
          }
          showAlert("Submissions refreshed successfully", "success");
        } catch (error) {
          showAlert("Failed to refresh submissions", "error");
        } finally {
          setRefreshLoading(false);
        }
      }

      useEffect(() => {
        if (open) {
          document.body.classList.add("overflow-hidden");
        }
        return () => {
          document.body.classList.remove("overflow-hidden");
        };
      }, [open]);

      const [modalOpens, setModalOpens] = useState(false);
      const handleCloseModal = () => {
        setModalOpens(false);
      };

      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    return (
        <>
          <Wrapper onSubmit={(e) => e.preventDefault()}>
            <div style={{ position: 'absolute', left: '-9999px', top: 0, width: '210mm' }}>
                <AssignmentPrintView
                    ref={pdfContentRef}
                    questions={pdfData.pdfQuestions}
                    answers={pdfData.pdfAnswers}
                    studentName={pdfData.pdfStudentName}
                    classDisplayName={pdfData.pdfClassName}
                    activityTitle={pdfData.pdfActivityTitle}
                    overallGrade={pdfData.pdfOverallGrade}
                    proficiencyLevel={pdfData.pdfProficiencyLevel}
                    aiGrades={pdfData.pdfAiGrades}
                    aiFeedbacks={pdfData.pdfAiFeedbacks}
                    aiSuggestions={pdfData.pdfAiSuggestions}
                />
            </div>
            <SpinLoader dataloader={loadingQuestions} />
          <AlertSakeBar
            open={alertSakeBar?.open}
            message={alertSakeBar?.message}
            severity={alertSakeBar?.severity}
            onClose={() => setAlertSakeBar({ open: false, message: "" })}
          />
            <AssignmentImgModal
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              page_src={page_src}
              title={is_soy_story ? getDisplayName(selectedAssignment) : ""}
              className="max-w-581px"
            />
            <StudentAssignmentTrackingModal
              open={Boolean(trackingLogId)}
              onClose={closeStudentTrackingModal}
              logId={trackingLogId || ''}
              attemptLabel={trackingSubmissionLabel}
              submissionId={submissionsData?.id}
              allLogSources={trackingLogSources}
            />
            <div>
        
        </div>

          <Header className={`${is_mobile_menu ? "tab-mobile-header-text" : ""} assignmentHeader`}>
            Student Assignment Review
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleRefresh}
              disabled={refreshLoading || !currentClass?.id}
              style={{ 
                fontSize: '12px',
                padding: '4px 12px',
                minWidth: 'auto',
                height: '28px'
              }}
            >
              {refreshLoading ? <Loading size={16} white /> : "Refresh"}
            </Button>
          </Header>
          
      
            
            {/* // for rubric laptop*/}
          {/* {!is_mobile_menu  && (
            <>
                {ShowAndHideRubric()}    
            </>      
          )} */}
           
               {/* // for laptop and mobile */}
            {!is_mobile_menu ? (
                 <SplitPane
                 split={"vertical"}
                 sizes={sizes}
                 onChange={handlePaneResize}
                //  className="customSplitPane custom-spilt-student"
                className={isIOS ? "customIosMobAndTab" : "customSplitPane custom-spilt-student"}
                 style={{
                   display: "flex",
                   height: "110vh",
                 }}
                 dividerStyle={{
                   backgroundColor: !is_mobile_menu ? "#ccc" : "",
                   width: !is_mobile_menu ? "5px" : "",
                   cursor: "col-resize",
                 }} 
               >
                   {panel1()}
                   {Panel2()}
               </SplitPane>
            ) : (
             <>
           
             {is_mobile_menu && (selectedAssignment?.isPreview ||  selectedAssignment?.isShowRubric) &&  (
                <div className='flex items-center back-forward-icon AssignmentBackSection'>
                  <BackText  style={{paddingLeft: "6px",marginBottom: "0px"}} onClick={()=>{
                    setSelectedAssignment(prev => {
                      const data = {...prev};
                       if(prev.isPreview){
                          if(prev.isShowRubric){
                              setAssignmentshow(false);
                              data.isShowRubric = false;
                              return data;
                          }
                          data.isPreview = false;
                      }
                      else if(prev.isShowRubric){
                          data.isShowRubric = false;
                          setAssignmentshow(false);
                      }

                      return data;
                  });
                    }} > <LeftOutlined />
                      <div>Back To Student List</div>
    
                    </BackText>
                </div>
                     )}
               
             {selectedAssignment?.isPreview ? (
                <div>
                    
                {!assignmentshow ? (
                    <>{panel1()}</>

                ) : 
                (
                  <>
                   <UserAddignmentLabel>
                        <div className='flex items-center'>
                          <HeaderWrapper>
                            <div className="flex items-center">
                              {is_mobile_menu && <ImagePoster />}
                              <strong style={{ marginRight: "6px" }}>Student:</strong>{" "}
                              <span style={{ marginRight: "3px" }}>
                              {SelectedUserDropDown()}
                              </span>{" "}
                            </div>
                            <div>
                              <strong style={{ marginLeft: "3px", marginRight: "6px" }}>
                                |{" "}
                                Status:{" "}
                              </strong>{" "}
                              {getStatus(get(selectedAssignment, "submissions", ""))}
                            </div>
                            <div>
                              <strong style={{ marginLeft: "3px", marginRight: "6px" }}>
                              | Due on:{" "}
                              </strong>{" "}
                              {getAssignmentDueOn()}
                            </div>
                        </HeaderWrapper>                      
                        </div>
                      </UserAddignmentLabel>
                  <GradebookRubric
                  assignmentRubrics={assignmentRubrics}
                  currentSubmissionRubric={currentSubmissionRubric}
                  loading={loading == "u"}
                  handleRubricUpdate={handleRubricUpdate}
                  type={"studentReviewSubmission"}
                  isMobileMenu={is_mobile_menu}
                />
                  </>
                )
                
                }
                <div>
                    {AudioRecorderAndGrade()}
                </div>

                </div>
                
             ) : (
                <>
                  {!assignmentshow ? (
                    <>
                          {UserSubsmissionList()}
                          <AssignmentDeviceModal
                            className="max-w-581px"
                            modalOpen={modalOpens}
                            setModalOpen={setModalOpens}
                            onClose={handleCloseModal}
                          />
                    </>
                ) : (
                  <>
                      <UserAddignmentLabel>
                        <div className='flex items-center'>
                          <HeaderWrapper>
                            <div className="flex items-center">
                              {is_mobile_menu && <ImagePoster />}
                              <strong style={{ marginRight: "6px" }}>Student:</strong>{" "}
                              <span style={{ marginRight: "3px" }}>
                                {SelectedUserDropDown()}
                              </span>{" "}
                            </div>
                            <div>
                              <strong style={{ marginLeft: "3px", marginRight: "6px" }}>
                                |{" "}
                                Status:{" "}
                              </strong>{" "}
                              {getStatus(get(selectedAssignment, "submissions", ""))}
                            </div>
                            <div>
                              <strong style={{ marginLeft: "3px", marginRight: "6px" }}>
                              | Due on:{" "}
                              </strong>{" "}
                              {getAssignmentDueOn()}
                            </div>
                        </HeaderWrapper>                      
                        </div>
                      </UserAddignmentLabel>
                      <GradebookRubric
                    assignmentRubrics={assignmentRubrics}
                    currentSubmissionRubric={currentSubmissionRubric}
                    loading={loading == "u"}
                    handleRubricUpdate={handleRubricUpdate}
                    type={"studentReviewSubmission"}
                    isMobileMenu={is_mobile_menu}
                />

                  </>
                )
              
                }
                 <div>
                    {AudioRecorderAndGrade()}
                </div>
                </>
             )}
            
             </>   
            )}
          </Wrapper>
      </>
        
    );
};


export default StudentReview;

const ImageStoryTitle = styled.div`
    position: absolute;
    top: 54.5%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    text-align: center;
    font-weight: bold;
    font-size: ${(props) => props?.fontSize ? props?.fontSize : "32px"};
    z-index: 1;
`;